import React from "react";


export default function Engranajes(props){
    const {goTo} = props;
    return <><svg xmlns="http://www.w3.org/2000/svg" width="100%"  height="auto"  viewBox="0 0 920.99998 526.00002"  version="1.1"  id="svg1464">
      <defs id="defs1458">
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath202">
          <path
             d="M 0,432 H 432 V 0 H 0 Z"
             id="path200"
              />
        </clipPath>
        <mask maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask236">
          <g
             id="g260">
            <g
              clipPath="url(#clipPath218)"
               id="g258">
              <path
                 d="M 28.448,403.32 H 386.531 V 136.152 H 28.448 Z"
                 style={
                        { 
                            fill: "#000000",
                            fillOpacity:1,
                            fillRule:"nonzero",
                            stroke:"none"
                    }}
                 id="path238"
                  />
              <g id="g256">
                <g id="g240" />
                <g id="g254">
                  <g clipPath="url(#clipPath222)" id="g252">
                    <g id="g250">
                      <g id="g248">
                        <g
                           id="g246">
                          <g
                             id="g244">
                            <path
                               d="m 383.428,301.167 3.103,-6.671 -340.529,-158.345 -3.329,7.157 12.353,8.198 8.41,5.609 c -2.536,6.493 -4.573,13.098 -6.177,19.715 l -10.129,-0.201 -14.787,-0.269 -1.229,7.146 -1.263,7.132 14.057,4.75 9.529,3.189 c -0.73,6.935 -0.98,13.822 -0.817,20.68 l -9.798,2.45 -14.374,3.544 0.663,7.223 0.639,7.262 14.744,0.922 10.114,0.634 c 1.105,6.815 2.622,13.543 4.543,20.152 l -8.865,4.889 -12.967,7.137 2.492,6.824 2.536,6.849 14.48,-2.949 9.946,-1.984 c 2.781,6.292 5.98,12.382 9.567,18.29 l -7.295,7.05 -10.657,10.267 4.169,5.908 4.188,5.965 13.245,-6.604 9.053,-4.5 c 4.337,5.37 8.996,10.427 14.015,15.273 l -5.197,8.597 -7.684,12.678 5.605,4.659 5.556,4.64 11.119,-9.788 7.554,-6.662 c 5.548,4.011 11.373,7.699 17.501,11.042 l -2.824,9.711 -4.116,14.24 6.609,3.03 6.613,3.074 8.184,-12.305 5.571,-8.433 c 6.513,2.488 13.111,4.529 19.758,6.152 l -0.24,10.11 -0.259,14.782 7.17,1.282 7.151,1.226 4.745,-14.043 3.18,-9.539 c 6.911,0.707 13.841,0.985 20.689,0.826 l 2.397,9.812 3.545,14.37 7.256,-0.639 7.243,-0.691 0.921,-14.749 0.635,-10.11 c 6.829,-1.062 13.581,-2.608 20.191,-4.534 l 4.879,8.875 7.146,12.967 6.825,-2.497 6.795,-2.516 -2.886,-14.509 -2.042,-9.918 c 6.302,-2.824 12.425,-6.003 18.347,-9.596 l 7.012,7.282 10.239,10.7 5.975,-4.188 5.912,-4.203 -6.561,-13.236 -4.49,-9.053 c 5.346,-4.293 10.417,-8.99 15.2,-13.995 l 8.659,5.182 12.636,7.67 4.702,-5.585 4.63,-5.561 -9.778,-11.119 -6.661,-7.56 c 3.991,-5.508 7.703,-11.372 11.041,-17.491 l 9.706,2.815 z"
                               style={{ fill: "url(#linearGradient234)",stroke:"none"}}
                               id="path242"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath218">
          <path
             d="M 28.4483,403.32 H 386.531 V 136.152 H 28.4483 Z"
             id="path216"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath222">
          <path
             d="M 28.4482,403.32 H 386.531 V 136.151 H 28.4482 Z"
             id="path220"
              />
        </clipPath>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(79.32782,-170.62254,-170.62254,-79.32782,136.94189,385.9375)"
           spreadMethod="pad"
           id="linearGradient234">
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0"
             id="stop228" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0.12507109"
             id="stop230" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="1"
             id="stop232" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath268">
          <path
             d="M 28.4483,403.32 H 386.531 V 136.152 H 28.4483 Z"
             id="path266"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask322">
          <g
             id="g354">
            <g
              clipPath="url(#clipPath292)"
               id="g352">
              <g
                 id="g350">
                <g
                   id="g324" />
                <g
                   id="g348">
                  <g
                    clipPath="url(#clipPath296)"
                     id="g346">
                    <g
                       id="g334">
                      <g
                         id="g332">
                        <g
                           id="g330">
                          <g
                             id="g328">
                            <path
                               d="M 323.378,129.321 127.025,323.695 c 0.884,0.735 1.763,1.431 2.662,2.147 0.095,0.062 0.163,0.135 0.268,0.202 54.237,42.21 132.708,38.627 182.862,-11.027 50.16,-49.66 54.535,-128.069 12.881,-182.742 -0.077,-0.101 -0.144,-0.173 -0.202,-0.264 -0.696,-0.913 -1.397,-1.791 -2.118,-2.69"
                               style={{ fill: "url(#linearGradient308)",stroke:"none"}}
                               id="path326"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                       id="g344">
                      <g
                         id="g342">
                        <g
                           id="g340">
                          <g
                             id="g338">
                            <path
                               d="M 323.378,129.321 127.025,323.695 c 0.884,0.735 1.763,1.431 2.662,2.147 0.095,0.062 0.163,0.135 0.268,0.202 54.237,42.21 132.708,38.627 182.862,-11.027 50.16,-49.66 54.535,-128.069 12.881,-182.742 -0.077,-0.101 -0.144,-0.173 -0.202,-0.264 -0.696,-0.913 -1.397,-1.791 -2.118,-2.69"
                               style={{ fill: "url(#linearGradient320)",stroke:"none"}}
                               id="path336"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath292">
          <path
             d="M 127.025,355.198 H 353.991 V 129.321 H 127.025 Z"
             id="path290"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath296">
          <path
             d="M 127.025,368.254 H 367.352 V 129.321 H 127.025 Z"
             id="path294"
              />
        </clipPath>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(87.624382,88.508598,88.508598,-87.624382,225.19727,226.50391)"
           spreadMethod="pad"
           id="linearGradient308">
          <stop
             style={{stopOpacity:1,stopColor:"#d9e0e2"}}
             offset="0"
             id="stop302" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0.997901"
             id="stop304" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="1"
             id="stop306" />
        </linearGradient>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(87.624382,88.508598,88.508598,-87.624382,225.19727,226.50391)"
           spreadMethod="pad"
           id="linearGradient320">
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0"
             id="stop314" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="0.997901"
             id="stop316" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="1"
             id="stop318" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath362">
          <path
             d="M 127.025,355.198 H 353.991 V 129.321 H 127.025 Z"
             id="path360"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath1138">
          <path
             d="M 0,432 H 432 V 0 H 0 Z"
             id="path1136"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask1172">
          <g
             id="g1196">
            <g clipPath="url(#clipPath1154)" id="g1194" style={{opacity:0.72000098}}>
              <path
                 d="M 147.191,403.943 H 403.943 V 28.567 H 147.191 Z"
                 style={{ fill: "#000000",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                 id="path1174"
                  />
              <g
                 id="g1192">
                <g
                   id="g1176" />
                <g
                   id="g1190">
                  <g
                    clipPath="url(#clipPath1158)"
                     id="g1188">
                    <g
                       id="g1186">
                      <g
                         id="g1184">
                        <g
                           id="g1182">
                          <g
                             id="g1180">
                            <path
                               d="m 281.377,36.749 -29.637,-8.182 -6.936,25.134 c -3.679,-0.673 -7.407,-1.19 -11.091,-1.568 l -86.522,313.608 c 3.342,1.605 6.816,3.029 10.315,4.376 l -6.931,25.133 29.636,8.182 6.931,-25.14 c 18.69,3.331 37.356,3.337 55.257,0.41 l 6.565,25.241 29.78,-7.773 -6.558,-25.241 c 17.403,-6.342 33.675,-15.546 48.012,-27.28 l 18.336,18.623 21.904,-21.599 -18.304,-18.575 c 11.692,-13.868 21.262,-29.894 27.947,-47.652 l 25.176,6.943 8.175,-29.636 -25.175,-6.949 c 3.366,-18.672 3.36,-37.301 0.444,-55.245 L 403.943,183 396.2,153.262 l -25.277,6.552 c -6.294,-17.426 -15.545,-33.675 -27.232,-48.043 L 362.26,93.467 340.667,71.561 322.104,89.83 C 308.236,78.132 292.203,68.567 274.445,61.877 Z"
                               style={{ fill: "url(#linearGradient1170)",stroke:"none"}}
                               id="path1178"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath1154">
          <path
             d="M 147.191,403.943 H 403.943 V 28.5672 H 147.191 Z"
             id="path1152"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath1158">
          <path
             d="M 147.191,403.943 H 403.943 V 28.5674 H 147.191 Z"
             id="path1156"
              />
        </clipPath>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(-208.89821,-57.642036,-57.642036,208.89821,399.33887,266.5957)"
           spreadMethod="pad"
           id="linearGradient1170">
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0"
             id="stop1164" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0.12507109"
             id="stop1166" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="1"
             id="stop1168" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath1204">
          <path
             d="M 147.191,403.943 H 403.943 V 28.5672 H 147.191 Z"
             id="path1202"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask1258">
          <g
             id="g1290">
            <g
              clipPath="url(#clipPath1228)"
               id="g1288">
              <g
                 id="g1286">
                <g
                   id="g1260" />
                <g
                   id="g1284">
                  <g
                    clipPath="url(#clipPath1232)"
                     id="g1282">
                    <g
                       id="g1270">
                      <g
                         id="g1268">
                        <g
                           id="g1266">
                          <g
                             id="g1264">
                            <path
                               d="M 345.817,229.434 H 82.849 c 0.114,1.082 0.228,2.146 0.36,3.228 0.024,0.114 0.024,0.204 0.048,0.318 8.429,64.869 63.902,114.986 131.073,114.986 67.177,0 122.65,-50.117 131.078,-114.986 0.025,-0.114 0.025,-0.204 0.042,-0.318 0.138,-1.082 0.253,-2.146 0.367,-3.228"
                               style={{ fill: "url(#linearGradient1244)",stroke:"none"}}
                               id="path1262"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                       id="g1280">
                      <g
                         id="g1278">
                        <g
                           id="g1276">
                          <g
                             id="g1274">
                            <path
                               d="M 345.817,229.434 H 82.849 c 0.114,1.082 0.228,2.146 0.36,3.228 0.024,0.114 0.024,0.204 0.048,0.318 8.429,64.869 63.902,114.986 131.073,114.986 67.177,0 122.65,-50.117 131.078,-114.986 0.025,-0.114 0.025,-0.204 0.042,-0.318 0.138,-1.082 0.253,-2.146 0.367,-3.228"
                               style={{ fill: "url(#linearGradient1256)",stroke:"none"}}
                               id="path1272"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath1228">
          <path
             d="M 82.8486,347.966 H 345.818 V 229.434 H 82.8486 Z"
             id="path1226"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath1232">
          <path
             d="M 82.8486,347.966 H 345.817 V 229.434 H 82.8486 Z"
             id="path1230"
              />
        </clipPath>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(0,118.53223,118.53223,0,214.33301,229.43408)"
           spreadMethod="pad"
           id="linearGradient1244">
          <stop
             style={{stopOpacity:1,stopColor:"#d9e0e2"}}
             offset="0"
             id="stop1238" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0.997901"
             id="stop1240" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="1"
             id="stop1242" />
        </linearGradient>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(0,118.53223,118.53223,0,214.33301,229.43408)"
           spreadMethod="pad"
           id="linearGradient1256">
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0"
             id="stop1250" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="0.997901"
             id="stop1252" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="1"
             id="stop1254" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath1298">
          <path
             d="M 82.8486,347.966 H 345.818 V 229.434 H 82.8486 Z"
             id="path1296"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath758">
          <path
             d="m 205.055,362.732 c -3.859,-0.17 -8.835,9.057 -13.818,18.284 v 0 c -5.13,9.498 -10.266,18.996 -14.195,18.244 v 0 c -7.702,-1.47 -5.16,-41.691 -12.632,-44.271 v 0 c -3.637,-1.248 -11.004,6.191 -18.385,13.629 v 0 c -7.609,7.668 -15.231,15.336 -18.796,13.491 v 0 c -6.938,-3.547 6.892,-41.401 0.423,-46.035 v 0 c -3.116,-2.205 -12.247,2.841 -21.412,7.886 v 0 c -9.477,5.218 -18.991,10.435 -21.932,7.639 v 0 c -5.778,-5.496 18.127,-37.965 13.327,-44.078 v 0 c -2.444,-3.066 -12.726,-0.787 -22.981,1.491 v 0 c -10.513,2.337 -20.997,4.673 -22.971,1.25 v 0 c -3.976,-6.827 28.134,-31.239 25.218,-38.494 v 0 C 73.957,264.439 33.91,268.995 32.045,261.38 v 0 c -1.834,-7.652 35.83,-22.002 35.08,-29.824 v 0 C 66.374,223.743 26.64,216.851 27.014,208.996 v 0 c 0.345,-7.845 40.521,-11.056 42.009,-18.795 v 0 c 1.451,-7.698 -34.73,-25.466 -32.165,-32.924 v 0 c 1.28,-3.737 11.999,-3.475 22.753,-3.212 v 0 c 10.514,0.256 21.064,0.514 22.868,-2.966 v 0 c 3.552,-6.924 -26.125,-34.214 -21.523,-40.673 v 0 c 2.273,-3.205 12.469,0.084 22.708,3.373 v 0 c 10.017,3.217 20.075,6.435 22.798,3.574 v 0 c 5.51,-5.786 -15.332,-40.291 -9.237,-45.081 v 0 c 3.166,-2.51 12.142,3.551 21.093,9.612 v 0 c 8.669,5.869 17.314,11.74 20.63,9.823 v 0 c 6.837,-3.994 -3.39,-42.967 3.861,-45.86 v 0 c 3.714,-1.501 10.58,6.835 17.44,15.172 v 0 c 6.661,8.095 13.317,16.19 17.074,15.278 v 0 c 7.638,-1.861 8.845,-42.151 16.639,-42.925 v 0 c 7.85,-0.737 16.705,38.595 24.563,38.963 v 0 c 3.864,0.172 8.846,-9.056 13.832,-18.285 v 0 c 5.13,-9.496 10.264,-18.992 14.192,-18.246 v 0 c 7.697,1.456 5.154,41.706 12.622,44.262 v 0 c 3.643,1.249 11.008,-6.189 18.388,-13.625 v 0 c 7.606,-7.666 15.229,-15.331 18.811,-13.486 v 0 c 6.947,3.552 -6.909,41.424 -0.423,46.026 v 0 c 3.109,2.216 12.243,-2.828 21.41,-7.871 v 0 c 9.47,-5.209 18.976,-10.419 21.911,-7.626 v 0 c 5.782,5.496 -18.117,37.959 -13.303,44.045 v 0 c 2.433,3.09 12.742,0.807 23.013,-1.475 v 0 c 10.504,-2.335 20.97,-4.669 22.939,-1.257 v 0 c 3.961,6.85 -28.124,31.248 -25.223,38.494 v 0 c 2.925,7.339 42.995,2.779 44.843,10.403 v 0 c 1.847,7.647 -35.823,21.987 -35.058,29.796 v 0 c 0.746,7.832 40.471,14.727 40.107,22.582 v 0 c -0.35,7.841 -40.535,11.056 -42.005,18.795 v 0 c -1.497,7.69 34.717,25.458 32.16,32.929 v 0 c -1.293,3.739 -12.022,3.473 -22.779,3.206 v 0 c -10.514,-0.261 -21.054,-0.521 -22.837,2.959 v 0 c -3.561,6.938 26.111,34.223 21.495,40.7 v 0 c -2.273,3.196 -12.463,-0.096 -22.7,-3.388 v 0 c -10.019,-3.222 -20.081,-6.444 -22.8,-3.582 v 0 c -5.501,5.781 15.331,40.286 9.254,45.096 v 0 c -3.17,2.503 -12.145,-3.556 -21.092,-9.615 v 0 c -8.671,-5.87 -17.317,-11.742 -20.631,-9.821 v 0 c -6.86,3.966 3.367,42.962 -3.879,45.874 v 0 c -3.718,1.48 -10.581,-6.852 -17.435,-15.184 v 0 c -6.661,-8.097 -13.312,-16.193 -17.06,-15.285 v 0 c -7.666,1.87 -8.845,42.147 -16.663,42.898 v 0 c -0.074,0.007 -0.149,0.01 -0.223,0.01 v 0 c -7.773,0.005 -16.559,-38.595 -24.336,-38.952 M 183.21,190.367 c -14.999,15.769 -14.377,40.737 1.41,55.755 v 0 c 15.792,15.014 40.752,14.373 55.75,-1.396 v 0 c 15.01,-15.787 14.397,-40.751 -1.396,-55.759 v 0 c -7.632,-7.259 -17.415,-10.861 -27.177,-10.862 v 0 c -10.43,0 -20.837,4.109 -28.587,12.262"
             id="path756"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask774">
          <g
             id="g784">
            <g
               id="g782">
              <g
                 id="g780">
                <g
                   id="g778">
                  <path
                     d="M -32768,32767 H 32767 V -32768 H -32768 Z"
                     style={{ fill: "url(#linearGradient772)",stroke:"none"}}
                     id="path776"
                      />
                </g>
              </g>
            </g>
          </g>
        </mask>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(369.5773,0,0,-369.5773,27.010925,217.533)"
           spreadMethod="pad"
           id="linearGradient772">
          <stop
             style={{stopOpacity:0.90000763,stopColor:"#ffffff"}}
             offset="0"
             id="stop768" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="1"
             id="stop770" />
        </linearGradient>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(369.5773,0,0,-369.5773,27.010925,217.533)"
           spreadMethod="pad"
           id="linearGradient794">
          <stop
             style={{stopOpacity:1,stopColor:"#231f20"}}
             offset="0"
             id="stop790" />
          <stop
             style={{stopOpacity:1,stopColor:"#231f20"}}
             offset="1"
             id="stop792" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath804">
          <path
             d="M 0,432 H 432 V 0 H 0 Z"
             id="path802"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask854">
          <g
             id="g886">
            <g
              clipPath="url(#clipPath824)"
               id="g884">
              <g
                 id="g882">
                <g
                   id="g856" />
                <g
                   id="g880">
                  <g
                    clipPath="url(#clipPath828)"
                     id="g878">
                    <g
                       id="g866">
                      <g
                         id="g864">
                        <g
                           id="g862">
                          <g
                             id="g860">
                            <path
                               d="M 311.112,132.69 132.025,321.005 c 0.843,0.659 1.699,1.295 2.557,1.94 0.101,0.069 0.165,0.128 0.267,0.183 52.194,38.149 125.851,32.552 171.605,-15.551 45.75,-48.109 47.649,-121.964 6.925,-172.179 -0.066,-0.086 -0.134,-0.151 -0.203,-0.252 -0.677,-0.834 -1.364,-1.631 -2.064,-2.456"
                               style={{ fill: "url(#linearGradient840)",stroke:"none"}}
                               id="path858"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                       id="g876">
                      <g
                         id="g874">
                        <g
                           id="g872">
                          <g
                             id="g870">
                            <path
                               d="M 311.112,132.69 132.025,321.005 c 0.843,0.659 1.699,1.295 2.557,1.94 0.101,0.069 0.165,0.128 0.267,0.183 52.194,38.149 125.851,32.552 171.605,-15.551 45.75,-48.109 47.649,-121.964 6.925,-172.179 -0.066,-0.086 -0.134,-0.151 -0.203,-0.252 -0.677,-0.834 -1.364,-1.631 -2.064,-2.456"
                               style={{ fill: "url(#linearGradient852)",stroke:"none"}}
                               id="path868"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath824">
          <path
             d="M 132.025,348.183 H 342.428 V 132.69 H 132.025 Z"
             id="path822"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath828">
          <path
             d="M 132.025,361.277 H 354.103 V 132.69 H 132.025 Z"
             id="path826"
              />
        </clipPath>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(84.887382,80.728538,80.728538,-84.887382,221.56738,226.84717)"
           spreadMethod="pad"
           id="linearGradient840">
          <stop
             style={{stopOpacity:1,stopColor:"#d9e0e2"}}
             offset="0"
             id="stop834" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0.997901"
             id="stop836" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="1"
             id="stop838" />
        </linearGradient>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(84.887382,80.728538,80.728538,-84.887382,221.56738,226.84717)"
           spreadMethod="pad"
           id="linearGradient852">
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0"
             id="stop846" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="0.997901"
             id="stop848" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="1"
             id="stop850" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath894">
          <path
             d="M 132.025,348.183 H 342.428 V 132.69 H 132.025 Z"
             id="path892"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath386">
          <path
             d="M 0,432 H 432 V 0 H 0 Z"
             id="path384"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask420">
          <g
             id="g444">
            <g
              clipPath="url(#clipPath402)"
               id="g442">
              <path
                 d="M 166.492,398.424 H 398.434 V 40.513 H 166.492 Z"
                 style={{ fill: "#000000",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                 id="path422"
                  />
              <g
                 id="g440">
                <g
                   id="g424" />
                <g
                   id="g438">
                  <g
                    clipPath="url(#clipPath406)"
                     id="g436">
                    <g
                       id="g434">
                      <g
                         id="g432">
                        <g
                           id="g430">
                          <g
                             id="g428">
                            <path
                               d="m 265.623,40.513 -99.131,351.012 c 2.126,0.443 5.994,-5.78 8.078,-5.262 2.132,0.509 2.688,7.965 4.805,8.398 2.142,0.447 5.605,-6.176 7.736,-5.824 2.175,0.367 3.264,7.755 5.419,8.045 2.156,0.281 5.124,-6.579 7.294,-6.38 2.169,0.201 3.792,7.498 5.961,7.613 2.184,0.138 4.639,-6.932 6.809,-6.889 2.188,0.047 4.348,7.198 6.522,7.17 2.194,-0.043 4.106,-7.256 6.285,-7.38 2.179,-0.114 4.853,6.861 7.023,6.661 2.179,-0.199 3.554,-7.531 5.723,-7.812 2.156,-0.285 5.343,6.47 7.494,6.118 2.155,-0.342 3.002,-7.769 5.129,-8.207 2.14,-0.428 5.813,6.076 7.92,5.567 2.132,-0.509 2.422,-7.989 4.516,-8.578 2.094,-0.59 6.237,5.642 8.325,4.981 2.061,-0.671 1.823,-8.14 3.859,-8.887 2.05,-0.743 6.637,5.162 8.665,4.339 2.007,-0.804 1.236,-8.236 3.22,-9.121 1.979,-0.89 6.998,4.658 8.94,3.707 1.955,-0.967 0.638,-8.312 2.55,-9.345 1.922,-1.032 7.327,4.14 9.192,3.04 1.884,-1.094 0.028,-8.321 1.874,-9.496 1.827,-1.161 7.579,3.611 9.378,2.379 1.793,-1.228 -0.585,-8.317 1.175,-9.606 1.741,-1.298 7.831,3.031 9.534,1.67 1.703,-1.337 -1.185,-8.255 0.467,-9.662 1.65,-1.428 8.04,2.468 9.638,0.994 1.599,-1.489 -1.798,-8.146 -0.243,-9.701 1.528,-1.527 8.189,1.893 9.673,0.29 1.484,-1.579 -2.369,-7.983 -0.946,-9.629 1.431,-1.637 8.316,1.27 9.672,-0.438 1.37,-1.69 -2.95,-7.784 -1.647,-9.549 1.29,-1.727 8.369,0.671 9.612,-1.132 1.246,-1.789 -3.517,-7.546 -2.351,-9.382 1.161,-1.837 8.411,0.033 9.516,-1.851 1.093,-1.88 -4.082,-7.27 -3.037,-9.197 1.019,-1.908 8.384,-0.576 9.335,-2.541 0.956,-1.955 -4.586,-6.946 -3.701,-8.949 0.89,-1.983 8.335,-1.189 9.135,-3.211 0.817,-2.008 -5.081,-6.604 -4.33,-8.659 0.733,-2.032 8.207,-1.785 8.868,-3.863 0.671,-2.061 -5.537,-6.228 -4.957,-8.341 0.6,-2.093 8.074,-2.383 8.583,-4.491 0.524,-2.122 -5.976,-5.814 -5.538,-7.946 0.437,-2.145 7.864,-2.963 8.221,-5.114 0.372,-2.14 -6.384,-5.362 -6.099,-7.512 0.29,-2.151 7.631,-3.53 7.831,-5.69 0.199,-2.184 -6.761,-4.882 -6.632,-7.06 0.123,-2.185 7.346,-4.078 7.403,-6.243 0.043,-2.183 -7.118,-4.386 -7.146,-6.551 -0.048,-2.185 7.022,-4.615 6.922,-6.779 -0.119,-2.175 -7.412,-3.84 -7.598,-6.005 -0.214,-2.17 6.657,-5.1 6.399,-7.27 -0.29,-2.16 -7.679,-3.283 -8.035,-5.423 -0.362,-2.156 6.27,-5.586 5.851,-7.732 -0.447,-2.122 -7.878,-2.702 -8.392,-4.814 -0.524,-2.118 5.857,-6.038 5.262,-8.131 -0.591,-2.104 -8.069,-2.117 -8.735,-4.197 -0.666,-2.065 5.414,-6.432 4.667,-8.478 -0.742,-2.056 -8.207,-1.532 -9.006,-3.549 -0.828,-2.022 4.909,-6.813 4.02,-8.826 -0.88,-1.979 -8.279,-0.918 -9.245,-2.878 -0.951,-1.946 4.416,-7.155 3.388,-9.068 -1.037,-1.922 -8.325,-0.333 -9.434,-2.199 -1.089,-1.888 3.887,-7.469 2.716,-9.3 -1.151,-1.847 -8.33,0.28 -9.562,-1.518 -1.228,-1.799 3.32,-7.718 2.031,-9.477 -1.294,-1.742 -8.293,0.894 -9.653,-0.809 -1.362,-1.708 2.76,-7.945 1.346,-9.602 -1.422,-1.65 -8.207,1.495 -9.691,-0.104 -1.475,-1.599 2.169,-8.126 0.647,-9.668 -1.541,-1.541 -8.088,2.075 -9.668,0.6 -1.604,-1.495 1.565,-8.269 -0.077,-9.677 -1.655,-1.433 -7.901,2.664 -9.609,1.284 -1.685,-1.351 0.989,-8.34 -0.781,-9.658 -1.741,-1.289 -7.664,3.255 -9.467,2.017 -1.789,-1.246 0.356,-8.402 -1.494,-9.577 -1.837,-1.166 -7.422,3.807 -9.287,2.697 -1.894,-1.098 -0.281,-8.392 -2.198,-9.434 -1.918,-1.018 -7.127,4.34 -9.087,3.374 -1.947,-0.962 -0.881,-8.346 -2.874,-9.254 -1.989,-0.881 -6.789,4.843 -8.812,4.039 -2.008,-0.818 -1.493,-8.264 -3.53,-9.025 -2.045,-0.738 -6.423,5.339 -8.507,4.668 -2.04,-0.676 -2.083,-7.98 -4.129,-8.712"
                               style={{ fill: "url(#linearGradient418)",stroke:"none"}}
                               id="path426"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath402">
          <path
             d="M 166.492,398.396 H 398.391 V 40.5128 H 166.492 Z"
             id="path400"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath406">
          <path
             d="M 166.492,398.424 H 398.434 V 40.5127 H 166.492 Z"
             id="path404"
              />
        </clipPath>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(-175.33527,-49.518005,-49.518005,175.33527,391.3916,265.53711)"
           spreadMethod="pad"
           id="linearGradient418">
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0"
             id="stop412" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0.12507109"
             id="stop414" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="1"
             id="stop416" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath452">
          <path
             d="M 166.492,398.396 H 398.391 V 40.5128 H 166.492 Z"
             id="path450"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask506">
          <g
             id="g538">
            <g
              clipPath="url(#clipPath476)"
               id="g536">
              <g
                 id="g534">
                <g
                   id="g508" />
                <g
                   id="g532">
                  <g
                    clipPath="url(#clipPath480)"
                     id="g530">
                    <g
                       id="g518">
                      <g
                         id="g516">
                        <g
                           id="g514">
                          <g
                             id="g512">
                            <path
                               d="M 302.909,134.663 149.34,313.271 c 0.8,0.552 1.584,1.099 2.398,1.632 0.09,0.057 0.152,0.119 0.238,0.162 48.99,32.157 115.421,23.75 154.654,-21.877 39.231,-45.626 37.585,-112.566 -1.552,-156.175 -0.066,-0.081 -0.133,-0.129 -0.185,-0.219 -0.662,-0.724 -1.313,-1.418 -1.984,-2.131"
                               style={{ fill: "url(#linearGradient492)",stroke:"none"}}
                               id="path510"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                       id="g528">
                      <g
                         id="g526">
                        <g
                           id="g524">
                          <g
                             id="g522">
                            <path
                               d="M 302.909,134.663 149.34,313.271 c 0.8,0.552 1.584,1.099 2.398,1.632 0.09,0.057 0.152,0.119 0.238,0.162 48.99,32.157 115.421,23.75 154.654,-21.877 39.231,-45.626 37.585,-112.566 -1.552,-156.175 -0.066,-0.081 -0.133,-0.129 -0.185,-0.219 -0.662,-0.724 -1.313,-1.418 -1.984,-2.131"
                               style={{ fill: "url(#linearGradient504)",stroke:"none"}}
                               id="path520"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath476">
          <path
             d="M 149.34,334.398 H 335.254 V 134.663 H 149.34 Z"
             id="path474"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath480">
          <path
             d="M 149.34,347.222 H 345.861 V 134.663 H 149.34 Z"
             id="path478"
              />
        </clipPath>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(80.507881,69.231262,69.231262,-80.507881,226.11816,223.96143)"
           spreadMethod="pad"
           id="linearGradient492">
          <stop
             style={{stopOpacity:1,stopColor:"#d9e0e2"}}
             offset="0"
             id="stop486" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0.997901"
             id="stop488" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="1"
             id="stop490" />
        </linearGradient>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(80.507881,69.231262,69.231262,-80.507881,226.11816,223.96143)"
           spreadMethod="pad"
           id="linearGradient504">
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0"
             id="stop498" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="0.997901"
             id="stop500" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="1"
             id="stop502" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath546">
          <path
             d="M 149.34,334.398 H 335.254 V 134.663 H 149.34 Z"
             id="path544"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath18">
          <path
             d="M 0,432 H 432 V 0 H 0 Z"
             id="path16"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask52">
          <g
             id="g76">
            <g
              clipPath="url(#clipPath34)"
               id="g74">
              <path
                 d="m 165.539,400.69 h 234.3 V 39.132 h -234.3 z"
                 style={{ fill: "#000000",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                 id="path54"
                  />
              <g
                 id="g72">
                <g
                   id="g56" />
                <g
                   id="g70">
                  <g
                    clipPath="url(#clipPath38)"
                     id="g68">
                    <g
                       id="g66">
                      <g
                         id="g64">
                        <g
                           id="g62">
                          <g
                             id="g60">
                            <path
                               d="M 265.674,39.132 165.539,393.725 c 2.149,0.445 6.057,-5.842 8.166,-5.315 2.145,0.517 2.716,8.044 4.843,8.485 2.167,0.445 5.665,-6.242 7.824,-5.882 2.19,0.364 3.295,7.829 5.472,8.112 2.172,0.297 5.176,-6.637 7.365,-6.439 2.199,0.207 3.832,7.581 6.026,7.693 2.199,0.136 4.685,-6.996 6.875,-6.96 2.203,0.049 4.389,7.271 6.588,7.244 2.216,-0.045 4.146,-7.334 6.349,-7.455 2.199,-0.117 4.901,6.933 7.091,6.735 2.208,-0.206 3.597,-7.617 5.792,-7.9 2.172,-0.288 5.391,6.542 7.567,6.183 2.177,-0.342 3.026,-7.847 5.176,-8.288 2.167,-0.436 5.873,6.138 8.004,5.617 2.149,-0.513 2.446,-8.067 4.559,-8.665 2.118,-0.594 6.3,5.701 8.405,5.031 2.087,-0.674 1.852,-8.215 3.908,-8.975 2.068,-0.751 6.708,5.225 8.75,4.389 2.036,-0.818 1.245,-8.318 3.246,-9.213 2.006,-0.895 7.073,4.708 9.043,3.745 1.97,-0.98 0.639,-8.399 2.572,-9.443 1.938,-1.043 7.397,4.182 9.285,3.067 1.898,-1.102 0.028,-8.4 1.893,-9.587 1.849,-1.178 7.658,3.642 9.471,2.397 1.816,-1.237 -0.59,-8.4 1.186,-9.699 1.763,-1.313 7.914,3.062 9.641,1.686 1.718,-1.354 -1.2,-8.342 0.464,-9.762 1.668,-1.443 8.125,2.491 9.735,0.998 1.614,-1.497 -1.813,-8.224 -0.248,-9.789 1.557,-1.543 8.273,1.906 9.775,0.288 1.498,-1.597 -2.396,-8.067 -0.953,-9.731 1.445,-1.65 8.401,1.291 9.772,-0.445 1.381,-1.7 -2.982,-7.86 -1.668,-9.637 1.307,-1.748 8.462,0.67 9.712,-1.142 1.25,-1.812 -3.552,-7.63 -2.374,-9.483 1.169,-1.857 8.494,0.032 9.609,-1.87 1.11,-1.889 -4.123,-7.339 -3.062,-9.286 1.03,-1.929 8.471,-0.584 9.429,-2.572 0.967,-1.965 -4.627,-7.01 -3.736,-9.033 0.894,-2.011 8.413,-1.201 9.221,-3.247 0.833,-2.028 -5.138,-6.678 -4.37,-8.746 0.743,-2.055 8.287,-1.794 8.957,-3.903 0.675,-2.082 -5.593,-6.296 -5.008,-8.422 0.602,-2.127 8.156,-2.41 8.67,-4.542 0.53,-2.14 -6.036,-5.872 -5.595,-8.022 0.436,-2.171 7.946,-2.995 8.305,-5.171 0.378,-2.167 -6.452,-5.414 -6.16,-7.59 0.287,-2.176 7.707,-3.571 7.91,-5.746 0.202,-2.204 -6.827,-4.929 -6.696,-7.133 0.117,-2.203 7.415,-4.114 7.469,-6.303 0.045,-2.208 -7.181,-4.43 -7.212,-6.624 -0.05,-2.199 7.095,-4.658 6.991,-6.839 -0.116,-2.204 -7.486,-3.886 -7.679,-6.071 -0.211,-2.19 6.731,-5.157 6.461,-7.348 -0.284,-2.176 -7.748,-3.308 -8.116,-5.471 -0.36,-2.177 6.344,-5.648 5.913,-7.811 -0.445,-2.149 -7.955,-2.734 -8.472,-4.865 -0.535,-2.137 5.913,-6.098 5.315,-8.211 -0.589,-2.122 -8.152,-2.145 -8.822,-4.245 -0.675,-2.091 5.463,-6.497 4.712,-8.571 -0.751,-2.073 -8.287,-1.547 -9.101,-3.579 -0.832,-2.042 4.96,-6.888 4.07,-8.912 -0.9,-2.006 -8.369,-0.935 -9.344,-2.909 -0.962,-1.966 4.46,-7.227 3.417,-9.165 -1.043,-1.938 -8.408,-0.332 -9.524,-2.217 -1.106,-1.901 3.921,-7.545 2.743,-9.397 -1.169,-1.862 -8.417,0.278 -9.663,-1.534 -1.237,-1.817 3.364,-7.792 2.055,-9.573 -1.309,-1.754 -8.382,0.908 -9.753,-0.818 -1.376,-1.723 2.788,-8.026 1.362,-9.694 -1.443,-1.673 -8.296,1.501 -9.789,-0.109 -1.498,-1.614 2.19,-8.211 0.643,-9.766 -1.547,-1.556 -8.156,2.095 -9.758,0.602 -1.618,-1.511 1.579,-8.351 -0.076,-9.776 -1.673,-1.448 -7.986,2.694 -9.703,1.304 -1.714,-1.367 0.984,-8.426 -0.787,-9.753 -1.763,-1.313 -7.757,3.279 -9.57,2.028 -1.811,-1.25 0.356,-8.476 -1.51,-9.677 -1.853,-1.169 -7.496,3.845 -9.384,2.734 -1.907,-1.115 -0.279,-8.475 -2.222,-9.532 -1.929,-1.03 -7.195,4.379 -9.178,3.408 -1.964,-0.971 -0.885,-8.435 -2.905,-9.344 -2.005,-0.895 -6.852,4.887 -8.903,4.074 -2.019,-0.818 -1.502,-8.35 -3.561,-9.114 -2.068,-0.746 -6.489,5.391 -8.589,4.708 -2.073,-0.675 -2.113,-8.054 -4.181,-8.8"
                               style={{ fill: "url(#linearGradient50)",stroke:"none"}}
                               id="path58"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath34">
          <path
             d="M 165.539,400.663 H 399.794 V 39.1314 H 165.539 Z"
             id="path32"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath38">
          <path
             d="m 165.539,400.69 h 234.3 V 39.1318 h -234.3 z"
             id="path36"
              />
        </clipPath>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(-177.12747,-50.024155,-50.024155,177.12747,392.72949,266.45117)"
           spreadMethod="pad"
           id="linearGradient50">
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0"
             id="stop44" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0.12507109"
             id="stop46" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="1"
             id="stop48" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath84">
          <path
             d="M 165.539,400.663 H 399.794 V 39.1314 H 165.539 Z"
             id="path82"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask138">
          <g
             id="g170">
            <g
              clipPath="url(#clipPath108)"
               id="g168">
              <g
                 id="g166">
                <g
                   id="g140" />
                <g
                   id="g164">
                  <g
                    clipPath="url(#clipPath112)"
                     id="g162">
                    <g
                       id="g150">
                      <g
                         id="g148">
                        <g
                           id="g146">
                          <g
                             id="g144">
                            <path
                               d="M 314.194,141.387 135.139,308.373 c 0.765,0.665 1.511,1.313 2.294,1.969 0.089,0.063 0.144,0.126 0.234,0.184 46.931,38.819 116.529,37.722 162.269,-4.932 45.739,-42.66 51.683,-112.011 16.228,-161.536 -0.054,-0.09 -0.112,-0.149 -0.171,-0.244 -0.594,-0.822 -1.191,-1.618 -1.799,-2.427"
                               style={{ fill: "url(#linearGradient124)",stroke:"none"}}
                               id="path142"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                       id="g160">
                      <g
                         id="g158">
                        <g
                           id="g156">
                          <g
                             id="g154">
                            <path
                               d="M 314.194,141.387 135.139,308.373 c 0.765,0.665 1.511,1.313 2.294,1.969 0.089,0.063 0.144,0.126 0.234,0.184 46.931,38.819 116.529,37.722 162.269,-4.932 45.739,-42.66 51.683,-112.011 16.228,-161.536 -0.054,-0.09 -0.112,-0.149 -0.171,-0.244 -0.594,-0.822 -1.191,-1.618 -1.799,-2.427"
                               style={{ fill: "url(#linearGradient136)",stroke:"none"}}
                               id="path152"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath108">
          <path
             d="M 135.139,338.655 H 339.065 V 141.387 H 135.139 Z"
             id="path106"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath112">
          <path
             d="m 135.139,349.345 h 216.48 V 141.387 h -216.48 z"
             id="path110"
              />
        </clipPath>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(75.271469,80.712654,80.712654,-75.271469,224.66602,224.87939)"
           spreadMethod="pad"
           id="linearGradient124">
          <stop
             style={{stopOpacity:1,stopColor:"#d9e0e2"}}
             offset="0"
             id="stop118" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0.997901"
             id="stop120" />
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="1"
             id="stop122" />
        </linearGradient>
        <linearGradient
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(75.271469,80.712654,80.712654,-75.271469,224.66602,224.87939)"
           spreadMethod="pad"
           id="linearGradient136">
          <stop
             style={{stopOpacity:1,stopColor:"#ffffff"}}
             offset="0"
             id="stop130" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="0.997901"
             id="stop132" />
          <stop
             style={{stopOpacity:1,stopColor:"#000000"}}
             offset="1"
             id="stop134" />
        </linearGradient>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath178">
          <path
             d="M 135.139,338.655 H 339.065 V 141.387 H 135.139 Z"
             id="path176"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath758-6">
          <path
             d="m 205.055,362.732 c -3.859,-0.17 -8.835,9.057 -13.818,18.284 v 0 c -5.13,9.498 -10.266,18.996 -14.195,18.244 v 0 c -7.702,-1.47 -5.16,-41.691 -12.632,-44.271 v 0 c -3.637,-1.248 -11.004,6.191 -18.385,13.629 v 0 c -7.609,7.668 -15.231,15.336 -18.796,13.491 v 0 c -6.938,-3.547 6.892,-41.401 0.423,-46.035 v 0 c -3.116,-2.205 -12.247,2.841 -21.412,7.886 v 0 c -9.477,5.218 -18.991,10.435 -21.932,7.639 v 0 c -5.778,-5.496 18.127,-37.965 13.327,-44.078 v 0 c -2.444,-3.066 -12.726,-0.787 -22.981,1.491 v 0 c -10.513,2.337 -20.997,4.673 -22.971,1.25 v 0 c -3.976,-6.827 28.134,-31.239 25.218,-38.494 v 0 C 73.957,264.439 33.91,268.995 32.045,261.38 v 0 c -1.834,-7.652 35.83,-22.002 35.08,-29.824 v 0 C 66.374,223.743 26.64,216.851 27.014,208.996 v 0 c 0.345,-7.845 40.521,-11.056 42.009,-18.795 v 0 c 1.451,-7.698 -34.73,-25.466 -32.165,-32.924 v 0 c 1.28,-3.737 11.999,-3.475 22.753,-3.212 v 0 c 10.514,0.256 21.064,0.514 22.868,-2.966 v 0 c 3.552,-6.924 -26.125,-34.214 -21.523,-40.673 v 0 c 2.273,-3.205 12.469,0.084 22.708,3.373 v 0 c 10.017,3.217 20.075,6.435 22.798,3.574 v 0 c 5.51,-5.786 -15.332,-40.291 -9.237,-45.081 v 0 c 3.166,-2.51 12.142,3.551 21.093,9.612 v 0 c 8.669,5.869 17.314,11.74 20.63,9.823 v 0 c 6.837,-3.994 -3.39,-42.967 3.861,-45.86 v 0 c 3.714,-1.501 10.58,6.835 17.44,15.172 v 0 c 6.661,8.095 13.317,16.19 17.074,15.278 v 0 c 7.638,-1.861 8.845,-42.151 16.639,-42.925 v 0 c 7.85,-0.737 16.705,38.595 24.563,38.963 v 0 c 3.864,0.172 8.846,-9.056 13.832,-18.285 v 0 c 5.13,-9.496 10.264,-18.992 14.192,-18.246 v 0 c 7.697,1.456 5.154,41.706 12.622,44.262 v 0 c 3.643,1.249 11.008,-6.189 18.388,-13.625 v 0 c 7.606,-7.666 15.229,-15.331 18.811,-13.486 v 0 c 6.947,3.552 -6.909,41.424 -0.423,46.026 v 0 c 3.109,2.216 12.243,-2.828 21.41,-7.871 v 0 c 9.47,-5.209 18.976,-10.419 21.911,-7.626 v 0 c 5.782,5.496 -18.117,37.959 -13.303,44.045 v 0 c 2.433,3.09 12.742,0.807 23.013,-1.475 v 0 c 10.504,-2.335 20.97,-4.669 22.939,-1.257 v 0 c 3.961,6.85 -28.124,31.248 -25.223,38.494 v 0 c 2.925,7.339 42.995,2.779 44.843,10.403 v 0 c 1.847,7.647 -35.823,21.987 -35.058,29.796 v 0 c 0.746,7.832 40.471,14.727 40.107,22.582 v 0 c -0.35,7.841 -40.535,11.056 -42.005,18.795 v 0 c -1.497,7.69 34.717,25.458 32.16,32.929 v 0 c -1.293,3.739 -12.022,3.473 -22.779,3.206 v 0 c -10.514,-0.261 -21.054,-0.521 -22.837,2.959 v 0 c -3.561,6.938 26.111,34.223 21.495,40.7 v 0 c -2.273,3.196 -12.463,-0.096 -22.7,-3.388 v 0 c -10.019,-3.222 -20.081,-6.444 -22.8,-3.582 v 0 c -5.501,5.781 15.331,40.286 9.254,45.096 v 0 c -3.17,2.503 -12.145,-3.556 -21.092,-9.615 v 0 c -8.671,-5.87 -17.317,-11.742 -20.631,-9.821 v 0 c -6.86,3.966 3.367,42.962 -3.879,45.874 v 0 c -3.718,1.48 -10.581,-6.852 -17.435,-15.184 v 0 c -6.661,-8.097 -13.312,-16.193 -17.06,-15.285 v 0 c -7.666,1.87 -8.845,42.147 -16.663,42.898 v 0 c -0.074,0.007 -0.149,0.01 -0.223,0.01 v 0 c -7.773,0.005 -16.559,-38.595 -24.336,-38.952 M 183.21,190.367 c -14.999,15.769 -14.377,40.737 1.41,55.755 v 0 c 15.792,15.014 40.752,14.373 55.75,-1.396 v 0 c 15.01,-15.787 14.397,-40.751 -1.396,-55.759 v 0 c -7.632,-7.259 -17.415,-10.861 -27.177,-10.862 v 0 c -10.43,0 -20.837,4.109 -28.587,12.262"
             id="path756-8"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask774-9">
          <g
             id="g784-7">
            <g
               id="g782-1">
              <g
                 id="g780-3">
                <g
                   id="g778-7">
                  <path
                     d="M -32768,32767 H 32767 V -32768 H -32768 Z"
                     style={{ fill: "url(#linearGradient772)",stroke:"none"}}
                     id="path776-2"
                      />
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath804-6">
          <path
             d="M 0,432 H 432 V 0 H 0 Z"
             id="path802-4"
              />
        </clipPath>
        <mask
           maskUnits="userSpaceOnUse"
           x="0"
           y="0"
           width="1"
           height="1"
           id="mask854-2">
          <g
             id="g886-5">
            <g
              clipPath="url(#clipPath824-3)"
               id="g884-5">
              <g
                 id="g882-2">
                <g
                   id="g856-8" />
                <g
                   id="g880-3">
                  <g
                    clipPath="url(#clipPath828-2)"
                     id="g878-2">
                    <g
                       id="g866-3">
                      <g
                         id="g864-7">
                        <g
                           id="g862-3">
                          <g
                             id="g860-8">
                            <path
                               d="M 311.112,132.69 132.025,321.005 c 0.843,0.659 1.699,1.295 2.557,1.94 0.101,0.069 0.165,0.128 0.267,0.183 52.194,38.149 125.851,32.552 171.605,-15.551 45.75,-48.109 47.649,-121.964 6.925,-172.179 -0.066,-0.086 -0.134,-0.151 -0.203,-0.252 -0.677,-0.834 -1.364,-1.631 -2.064,-2.456"
                               style={{ fill: "url(#linearGradient840)",stroke:"none"}}
                               id="path858-6"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                       id="g876-9">
                      <g
                         id="g874-0">
                        <g
                           id="g872-4">
                          <g
                             id="g870-0">
                            <path
                               d="M 311.112,132.69 132.025,321.005 c 0.843,0.659 1.699,1.295 2.557,1.94 0.101,0.069 0.165,0.128 0.267,0.183 52.194,38.149 125.851,32.552 171.605,-15.551 45.75,-48.109 47.649,-121.964 6.925,-172.179 -0.066,-0.086 -0.134,-0.151 -0.203,-0.252 -0.677,-0.834 -1.364,-1.631 -2.064,-2.456"
                               style={{ fill: "url(#linearGradient852)",stroke:"none"}}
                               id="path868-0"
                                />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </mask>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath824-3">
          <path
             d="M 132.025,348.183 H 342.428 V 132.69 H 132.025 Z"
             id="path822-5"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath828-2">
          <path
             d="M 132.025,361.277 H 354.103 V 132.69 H 132.025 Z"
             id="path826-4"
              />
        </clipPath>
        <clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath894-9">
          <path
             d="M 132.025,348.183 H 342.428 V 132.69 H 132.025 Z"
             id="path892-5"
              />
        </clipPath>
        <linearGradient
           
           
           id="linearGradient3639"
           gradientUnits="userSpaceOnUse"
           gradientTransform="matrix(369.5773,0,0,-369.5773,27.010925,217.533)"
           x1="0"
           y1="0"
           x2="1"
           y2="0"
           spreadMethod="pad" />
      </defs>
      <g
         id="layer1"
         transform="translate(0,-596.51962)">
        <flowRoot
          
           id="flowRoot3177"
           style={
	{
	 fontStyle:"normal",
	 fontWeight:"normal",
	 fontSize:"40px",
	 lineHeight:1.25,
	 fontFamily:"sans-serif",
	 letterSpacing:"0px",
	 wordSpacing:"0px",
	 fill:"#000000",
	 fillOpacity:1,
	 stroke:"none"
	}
}
           transform="translate(0,596.51962)"><flowRegion
             id="flowRegion3179"><rect
               id="rect3181"
               width="91.529915"
               height="41.806053"
               x="85.195663"
               y="263.44531" /></flowRegion><flowPara
             id="flowPara3183">or</flowPara></flowRoot>    
        <g id="g3807" onClick={(evc)=>{
            console.log(goTo);
            props.history.push(goTo["OJ"]);
        }} style={{cursor:"pointer"}}>
          <g
             transform="matrix(0.52829647,0,0,-0.52829647,15.86508,828.75013)"
             id="g196">
            <g
               transform="translate(0,-9.0303562)"
              clipPath="url(#clipPath202)"
               id="g198">
              <g
                 transform="translate(383.3154,301.5259)"
                 id="g204">
                <path
                   
                   id="path206"
                   style={
                        {
                            fill:"#3c468e",fillOpacity:1,fillRule:"evenodd",stroke:"none"
                        }
                    }
                   d="m 0,0 6.123,-13.174 -12.342,-8.193 -8.424,-5.614 c 2.497,-6.518 4.567,-13.088 6.181,-19.715 l 10.085,0.192 14.827,0.278 1.224,-7.146 1.239,-7.189 -14.014,-4.693 -9.567,-3.237 c 0.749,-6.882 1.004,-13.774 0.864,-20.666 l 9.779,-2.416 14.374,-3.544 -0.639,-7.262 -0.667,-7.223 -14.783,-0.937 -10.062,-0.619 c -1.114,-6.81 -2.631,-13.539 -4.562,-20.152 l 8.885,-4.884 12.957,-7.137 -2.53,-6.849 -2.493,-6.824 -14.494,2.939 -9.937,1.989 c -2.786,-6.292 -6.008,-12.43 -9.553,-18.328 l 7.272,-7.012 10.666,-10.263 -4.212,-5.922 -4.145,-5.955 -13.288,6.589 -9.001,4.477 c -4.346,-5.326 -8.981,-10.432 -14.024,-15.235 l 5.197,-8.596 7.646,-12.694 -5.557,-4.639 -5.6,-4.659 -11.113,9.783 -7.531,6.681 c -5.527,-4.044 -11.348,-7.732 -17.477,-11.075 l 2.762,-9.687 4.126,-14.25 -6.571,-3.044 -6.623,-3.041 -8.178,12.309 -5.61,8.419 c -6.513,-2.497 -13.116,-4.533 -19.71,-6.176 l 0.182,-10.09 0.322,-14.807 -7.19,-1.239 -7.155,-1.229 -4.717,14.004 -3.208,9.577 c -6.906,-0.711 -13.832,-0.985 -20.685,-0.826 l -2.392,-9.817 -3.587,-14.384 -7.229,0.658 -7.247,0.643 -0.903,14.802 -0.634,10.1 c -6.834,1.062 -13.562,2.584 -20.19,4.539 l -4.889,-8.885 -7.146,-12.953 -6.825,2.493 -6.834,2.497 2.934,14.524 2.008,9.903 c -6.268,2.843 -12.396,6.027 -18.303,9.61 l -6.998,-7.315 -10.263,-10.662 -5.965,4.189 -5.936,4.206 6.57,13.232 4.505,9.053 c -5.345,4.298 -10.437,8.99 -15.254,13.976 l -8.606,-5.197 -12.688,-7.65 -4.645,5.561 -4.658,5.6 9.783,11.113 6.671,7.564 c -3.992,5.509 -7.68,11.335 -11.046,17.501 l -9.716,-2.824 -14.192,-4.101 -6.129,13.169 12.353,8.198 8.409,5.61 c -2.535,6.493 -4.572,13.097 -6.176,19.715 l -10.129,-0.202 -14.787,-0.269 -1.229,7.146 -1.264,7.132 14.058,4.75 9.528,3.189 c -0.73,6.935 -0.979,13.822 -0.816,20.68 l -9.798,2.45 -14.374,3.544 0.663,7.223 0.638,7.262 14.745,0.922 10.114,0.634 c 1.105,6.815 2.622,13.544 4.543,20.152 l -8.865,4.889 -12.967,7.137 2.492,6.825 2.536,6.848 14.48,-2.949 9.946,-1.983 c 2.781,6.291 5.98,12.381 9.567,18.289 l -7.295,7.05 -10.657,10.268 4.169,5.907 4.188,5.965 13.245,-6.604 9.054,-4.5 c 4.336,5.37 8.995,10.427 14.014,15.273 l -5.197,8.597 -7.684,12.678 5.605,4.659 5.556,4.64 11.118,-9.788 7.555,-6.662 c 5.547,4.011 11.373,7.699 17.501,11.042 l -2.824,9.711 -4.116,14.24 6.608,3.03 6.614,3.074 8.183,-12.305 5.572,-8.433 c 6.512,2.488 13.111,4.529 19.758,6.152 l -0.24,10.11 -0.259,14.783 7.17,1.282 7.151,1.225 4.745,-14.043 3.179,-9.539 c 6.912,0.706 13.842,0.985 20.69,0.826 l 2.397,9.812 3.544,14.37 7.257,-0.639 7.243,-0.691 0.922,-14.749 0.634,-10.11 c 6.829,-1.061 13.582,-2.608 20.19,-4.534 l 4.879,8.876 7.147,12.967 6.825,-2.498 6.795,-2.516 -2.886,-14.509 -2.041,-9.918 c 6.301,-2.823 12.424,-6.003 18.346,-9.595 l 7.012,7.281 10.239,10.7 5.975,-4.188 5.912,-4.203 -6.561,-13.236 -4.49,-9.053 c 5.345,-4.293 10.417,-8.99 15.201,-13.995 l 8.659,5.182 12.635,7.67 4.702,-5.585 4.63,-5.562 -9.778,-11.118 -6.662,-7.559 c 3.992,-5.509 7.704,-11.373 11.042,-17.492 l 9.706,2.815 z" />
              </g>
              <g
                 transform="translate(383.3154,301.5259)"
                 id="g208">
                <path
                   
                   id="path210"
                   style={{ fill: "none",stroke:"#4250a8",strokeWidth:3,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                   d="m 0,0 6.123,-13.174 -12.342,-8.193 -8.424,-5.614 c 2.497,-6.518 4.567,-13.088 6.181,-19.715 l 10.085,0.192 14.827,0.278 1.224,-7.146 1.239,-7.189 -14.014,-4.693 -9.567,-3.237 c 0.749,-6.882 1.004,-13.774 0.864,-20.666 l 9.779,-2.416 14.374,-3.544 -0.639,-7.262 -0.667,-7.223 -14.783,-0.937 -10.062,-0.619 c -1.114,-6.81 -2.631,-13.539 -4.562,-20.152 l 8.885,-4.884 12.957,-7.137 -2.53,-6.849 -2.493,-6.824 -14.494,2.939 -9.937,1.989 c -2.786,-6.292 -6.008,-12.43 -9.553,-18.328 l 7.272,-7.012 10.666,-10.263 -4.212,-5.922 -4.145,-5.955 -13.288,6.589 -9.001,4.477 c -4.346,-5.326 -8.981,-10.432 -14.024,-15.235 l 5.197,-8.596 7.646,-12.694 -5.557,-4.639 -5.6,-4.659 -11.113,9.783 -7.531,6.681 c -5.527,-4.044 -11.348,-7.732 -17.477,-11.075 l 2.762,-9.687 4.126,-14.25 -6.571,-3.044 -6.623,-3.041 -8.178,12.309 -5.61,8.419 c -6.513,-2.497 -13.116,-4.533 -19.71,-6.176 l 0.182,-10.09 0.322,-14.807 -7.19,-1.239 -7.155,-1.229 -4.717,14.004 -3.208,9.577 c -6.906,-0.711 -13.832,-0.985 -20.685,-0.826 l -2.392,-9.817 -3.587,-14.384 -7.229,0.658 -7.247,0.643 -0.903,14.802 -0.634,10.1 c -6.834,1.062 -13.562,2.584 -20.19,4.539 l -4.889,-8.885 -7.146,-12.953 -6.825,2.493 -6.834,2.497 2.934,14.524 2.008,9.903 c -6.268,2.843 -12.396,6.027 -18.303,9.61 l -6.998,-7.315 -10.263,-10.662 -5.965,4.189 -5.936,4.206 6.57,13.232 4.505,9.053 c -5.345,4.298 -10.437,8.99 -15.254,13.976 l -8.606,-5.197 -12.688,-7.65 -4.645,5.561 -4.658,5.6 9.783,11.113 6.671,7.564 c -3.992,5.509 -7.68,11.335 -11.046,17.501 l -9.716,-2.824 -14.192,-4.101 -6.129,13.169 12.353,8.198 8.409,5.61 c -2.535,6.493 -4.572,13.097 -6.176,19.715 l -10.129,-0.202 -14.787,-0.269 -1.229,7.146 -1.264,7.132 14.058,4.75 9.528,3.189 c -0.73,6.935 -0.979,13.822 -0.816,20.68 l -9.798,2.45 -14.374,3.544 0.663,7.223 0.638,7.262 14.745,0.922 10.114,0.634 c 1.105,6.815 2.622,13.544 4.543,20.152 l -8.865,4.889 -12.967,7.137 2.492,6.825 2.536,6.848 14.48,-2.949 9.946,-1.983 c 2.781,6.291 5.98,12.381 9.567,18.289 l -7.295,7.05 -10.657,10.268 4.169,5.907 4.188,5.965 13.245,-6.604 9.054,-4.5 c 4.336,5.37 8.995,10.427 14.014,15.273 l -5.197,8.597 -7.684,12.678 5.605,4.659 5.556,4.64 11.118,-9.788 7.555,-6.662 c 5.547,4.011 11.373,7.699 17.501,11.042 l -2.824,9.711 -4.116,14.24 6.608,3.03 6.614,3.074 8.183,-12.305 5.572,-8.433 c 6.512,2.488 13.111,4.529 19.758,6.152 l -0.24,10.11 -0.259,14.783 7.17,1.282 7.151,1.225 4.745,-14.043 3.179,-9.539 c 6.912,0.706 13.842,0.985 20.69,0.826 l 2.397,9.812 3.544,14.37 7.257,-0.639 7.243,-0.691 0.922,-14.749 0.634,-10.11 c 6.829,-1.061 13.582,-2.608 20.19,-4.534 l 4.879,8.876 7.147,12.967 6.825,-2.498 6.795,-2.516 -2.886,-14.509 -2.041,-9.918 c 6.301,-2.823 12.424,-6.003 18.346,-9.595 l 7.012,7.281 10.239,10.7 5.975,-4.188 5.912,-4.203 -6.561,-13.236 -4.49,-9.053 c 5.345,-4.293 10.417,-8.99 15.201,-13.995 l 8.659,5.182 12.635,7.67 4.702,-5.585 4.63,-5.562 -9.778,-11.118 -6.662,-7.559 c 3.992,-5.509 7.704,-11.373 11.042,-17.492 l 9.706,2.815 z" />
              </g>
              <g
                 id="g212">
                <g
                   id="g214" />
                <g
                   mask="url(#mask236)"
                   id="g262">
                  <g
                     id="g264" />
                  <g
                     id="g276">
                    <g
                       id="g274"
                      clipPath="url(#clipPath268)">
                      <g
                         id="g272"
                         transform="translate(383.4281,301.1669)">
                        <path
                           
                           id="path270"
                           style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                           d="m 0,0 3.103,-6.671 -340.529,-158.344 -3.329,7.156 12.353,8.198 8.409,5.61 c -2.535,6.493 -4.572,13.097 -6.176,19.715 l -10.129,-0.202 -14.787,-0.269 -1.229,7.146 -1.264,7.132 14.058,4.75 9.528,3.189 c -0.73,6.935 -0.979,13.822 -0.816,20.68 l -9.798,2.45 -14.374,3.544 0.663,7.223 0.638,7.262 14.745,0.922 10.114,0.634 c 1.105,6.815 2.622,13.544 4.543,20.152 l -8.865,4.889 -12.967,7.137 2.492,6.825 2.536,6.848 14.48,-2.949 9.946,-1.983 c 2.781,6.291 5.98,12.381 9.567,18.289 l -7.295,7.05 -10.657,10.268 4.169,5.907 4.188,5.965 13.245,-6.604 9.054,-4.5 c 4.336,5.37 8.995,10.427 14.014,15.273 l -5.197,8.597 -7.684,12.678 5.605,4.659 5.556,4.64 11.118,-9.788 7.555,-6.662 c 5.547,4.011 11.373,7.699 17.501,11.042 l -2.824,9.711 -4.116,14.24 6.608,3.03 6.614,3.074 8.183,-12.305 5.571,-8.433 c 6.513,2.488 13.112,4.529 19.759,6.152 l -0.24,10.11 -0.259,14.783 7.17,1.282 7.151,1.225 4.745,-14.043 3.179,-9.539 c 6.912,0.706 13.842,0.985 20.69,0.826 l 2.397,9.812 3.544,14.37 7.257,-0.639 7.243,-0.691 0.922,-14.749 0.634,-10.11 c 6.829,-1.061 13.582,-2.608 20.19,-4.534 l 4.879,8.876 7.147,12.967 6.825,-2.498 6.795,-2.516 -2.886,-14.509 -2.041,-9.918 c 6.301,-2.823 12.424,-6.003 18.346,-9.595 l 7.012,7.281 10.239,10.7 5.975,-4.188 5.912,-4.203 -6.561,-13.236 -4.49,-9.053 c 5.345,-4.293 10.417,-8.99 15.201,-13.995 l 8.659,5.182 12.635,7.67 4.702,-5.585 4.63,-5.562 -9.778,-11.118 -6.662,-7.559 c 3.992,-5.509 7.704,-11.373 11.042,-17.492 l 9.706,2.814 z" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g
                 transform="translate(314.6909,118.2991)"
                 id="g278">
                <path
                   
                   id="path280"
                   style={{ fill: "#3c468e",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c -53.963,-54.501 -141.881,-54.953 -196.386,-0.989 -54.515,53.958 -54.952,141.875 -0.995,196.381 53.954,54.515 141.872,54.962 196.387,0.999 C 53.512,142.438 53.963,54.506 0,0" />
              </g>
              <g
                 transform="translate(314.6909,118.2991)"
                 id="g282">
                <path
                   
                   id="path284"
                   style={{ fill: "none",stroke:"#4253a8",strokeWidth:3,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                   d="m 0,0 c -53.963,-54.501 -141.881,-54.953 -196.386,-0.989 -54.515,53.958 -54.952,141.875 -0.995,196.381 53.954,54.515 141.872,54.962 196.387,0.999 C 53.512,142.438 53.963,54.506 0,0 Z" />
              </g>
              <g
                 id="g286">
                <g
                   id="g288" />
                <g
                   mask="url(#mask322)"
                   id="g356">
                  <g
                     id="g358" />
                  <g
                     id="g370">
                    <g
                       id="g368"
                      clipPath="url(#clipPath362)">
                      <g
                         id="g366"
                         transform="translate(323.3781,129.3213)">
                        <path
                           
                           id="path364"
                           style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                           d="m 0,0 -196.353,194.374 c 0.884,0.734 1.763,1.431 2.661,2.146 0.096,0.063 0.164,0.135 0.269,0.203 54.237,42.21 132.708,38.627 182.862,-11.028 C 39.598,136.036 43.973,57.627 2.32,2.954 2.243,2.853 2.176,2.781 2.118,2.69 1.422,1.777 0.72,0.898 0,0" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g
                 transform="translate(155.9837,214.1289)"
                 id="g372">
                <path
                   
                   id="path374"
                   style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c 0.1,-5.258 0.999,-10.087 2.698,-14.485 1.698,-4.398 4.054,-8.184 7.069,-11.356 3.013,-3.174 6.59,-5.645 10.73,-7.41 4.14,-1.769 8.75,-2.603 13.824,-2.507 5.073,0.097 9.671,1.105 13.786,3.031 4.117,1.923 7.619,4.526 10.511,7.814 2.891,3.284 5.101,7.157 6.633,11.616 1.53,4.459 2.246,9.319 2.145,14.577 -0.092,4.889 -0.987,9.44 -2.681,13.654 -1.697,4.212 -4.049,7.883 -7.062,11.011 -3.014,3.127 -6.612,5.55 -10.799,7.271 -4.185,1.72 -8.817,2.532 -13.89,2.436 C 27.89,35.555 23.315,34.568 19.245,32.691 15.174,30.815 11.692,28.256 8.801,25.017 5.908,21.778 3.695,18.019 2.162,13.747 0.627,9.471 -0.093,4.889 0,0 m -18.247,-1.454 c -0.149,7.84 1.008,14.993 3.47,21.455 2.46,6.46 5.932,11.994 10.413,16.603 4.482,4.606 9.858,8.193 16.133,10.758 6.272,2.564 13.192,3.919 20.757,4.064 7.656,0.236 14.69,-0.76 21.1,-2.992 6.411,-2.232 11.964,-5.566 16.664,-9.997 4.699,-4.434 8.401,-9.808 11.105,-16.125 2.703,-6.317 4.131,-13.399 4.279,-21.238 0.146,-7.659 -1.014,-14.649 -3.478,-20.971 -2.464,-6.324 -5.959,-11.789 -10.486,-16.397 -4.528,-4.608 -9.949,-8.242 -16.267,-10.9 -6.317,-2.657 -13.306,-4.104 -20.962,-4.343 -7.565,-0.143 -14.531,0.948 -20.896,3.272 -6.368,2.324 -11.876,5.679 -16.528,10.068 -4.652,4.387 -8.33,9.693 -11.031,15.919 -2.703,6.225 -4.127,13.165 -4.273,20.824" />
              </g>
              <g
                 transform="translate(297.1552,194.2444)"
                 id="g376">
                <path
                   
                   id="path378"
                   style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c 0.073,-3.876 -0.478,-7.623 -1.657,-11.246 -1.176,-3.622 -2.963,-6.817 -5.355,-9.584 -2.394,-2.768 -5.421,-4.996 -9.08,-6.68 -3.66,-1.682 -7.935,-2.573 -12.824,-2.666 -7.75,-0.147 -14.128,1.532 -19.13,5.036 -5.005,3.505 -8.367,9.162 -10.082,16.976 l 16.255,4.185 c 0.615,-3.22 1.979,-5.777 4.092,-7.675 2.113,-1.898 4.691,-2.819 7.737,-2.761 4.981,0.095 8.339,1.841 10.075,5.245 1.734,3.4 2.545,8.054 2.433,13.959 l -1.248,65.735 17.438,0.332 z" />
              </g>
            </g>
          </g>
          <text
             id="text3187"
             y="844.01495"
             x="16.878149"
             style={
	{
	 fontStyle:"normal",
	 fontWeight:"normal",
	 fontSize:"40px",
	 lineHeight:1.25,
	 fontFamily:"sans-serif",
	 letterSpacing:"0px",
	 wordSpacing:"0px",
	 fill:"#000000",
	 fillOpacity:1,
	 stroke:"none"
	}
}
            ><tspan
               style={{fontSize:"24px"}}
               y="844.01495"
               x="16.878149"
               id="tspan3185"
               >Organismo Judicial</tspan></text>
        </g>
        <flowRoot
          
           id="flowRoot3189"
           style={
	{
	 fontStyle:"normal",
	 fontWeight:"normal",
	 fontSize:"40px",
	 lineHeight:1.25,
	 fontFamily:"sans-serif",
	 letterSpacing:"0px",
	 wordSpacing:"0px",
	 fill:"#000000",
	 fillOpacity:1,
	 stroke:"none"
	}
}
           transform="translate(0,596.51962)"><flowRegion
             id="flowRegion3191"><rect
               id="rect3193"
               width="82.661964"
               height="125.41816"
               x="374.6709"
               y="248.24312" /></flowRegion><flowPara
             id="flowPara3195">Instituto de la Defensa Pública Penal</flowPara><flowPara
             id="flowPara3197" /></flowRoot>    <flowRoot
          
           id="flowRoot3211"
           style={
	{
	 fontStyle:"normal",
	 fontWeight:"normal",
	 fontSize:"40px",
	 lineHeight:1.25,
	 fontFamily:"sans-serif",
	 letterSpacing:"0px",
	 wordSpacing:"0px",
	 fill:"#000000",
	 fillOpacity:1,
	 stroke:"none"
	}
}
           transform="translate(0,596.51962)"><flowRegion
             id="flowRegion3213"><rect
               id="rect3215"
               width="137.45323"
               height="64.292641"
               x="390.50653"
               y="269.77957" /></flowRegion><flowPara
             id="flowPara3217">Defensa Pública Penal</flowPara></flowRoot>    <flowRoot
          
           id="flowRoot3219"
           style={{ fill: "black",fillOpacity:1,stroke:"none",fontFamily:"sans-serif",fontStyle:"normal",fontWeight:"normal",fontSize:"40px",lineHeight:1.25,letterSpacing:"0px",wordSpacing:"0px"}}><flowRegion
             id="flowRegion3221"><rect
               id="rect3223"
               width="85.512383"
               height="102.61485"
               x="387.97284"
               y="272.62997" /></flowRegion><flowPara
             id="flowPara3225"></flowPara></flowRoot>    <g
           id="g3333"  onClick={(evc)=>{
            props.history.push(goTo["IDPP"]);
        }} style={{cursor:"pointer"}}
           transform="translate(2.0000024,-0.65848172)">
          <g
             transform="matrix(0.52509051,0,0,-0.52509051,165.88306,1069.7352)"
             id="g1132">
            <g
              clipPath="url(#clipPath1138)"
               id="g1134">
              <g
                 transform="translate(244.8037,53.7009)"
                 id="g1140">
                <path
                   
                   id="path1142"
                   style={{ fill: "#ff6d2e",fillOpacity:1,fillRule:"evenodd",stroke:"none"}}
                   d="m 0,0 6.937,-25.134 29.636,8.182 -6.931,25.128 C 47.4,14.867 63.432,24.431 77.3,36.129 L 95.863,17.86 117.457,39.766 98.887,58.07 c 11.687,14.367 20.938,30.617 27.232,48.043 l 25.278,-6.552 7.742,29.738 -25.241,6.559 c 2.915,17.944 2.922,36.574 -0.445,55.245 l 25.175,6.949 -8.175,29.636 -25.175,-6.943 c -6.685,17.758 -16.255,33.784 -27.947,47.652 l 18.304,18.575 -21.905,21.599 -18.336,-18.623 c -14.336,11.734 -30.609,20.938 -48.012,27.28 l 6.558,25.242 -29.78,7.772 -6.564,-25.241 c -17.902,2.927 -36.568,2.921 -55.257,-0.41 l -6.932,25.14 -29.635,-8.181 6.93,-25.134 c -3.498,-1.347 -6.973,-2.771 -10.315,-4.376 -13.688,-6.198 -26.18,-14.241 -37.331,-23.607 l -18.563,18.263 -21.557,-21.894 18.575,-18.304 c -11.728,-14.379 -20.943,-30.616 -27.273,-48.055 l -25.254,6.6 -7.731,-29.774 25.2,-6.571 c -2.91,-17.938 -2.88,-36.561 0.445,-55.245 l -25.128,-6.937 8.176,-29.636 25.134,6.937 c 6.684,-17.764 16.254,-33.79 27.946,-47.658 l -18.269,-18.563 21.906,-21.599 18.293,18.617 C -118.665,22.886 -102.428,13.67 -84.989,7.34 l -6.559,-25.242 29.739,-7.742 6.565,25.2 c 14.379,-2.321 29.233,-2.819 44.153,-1.124 C -7.406,-1.19 -3.679,-0.673 0,0" />
              </g>
              <g
                 transform="translate(244.8037,53.7009)"
                 id="g1144">
                <path
                   
                   id="path1146"
                   style={{ fill: "none",stroke:"#ffb17a",strokeWidth:4.09899998,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                   d="m 0,0 6.937,-25.134 29.636,8.182 -6.931,25.128 C 47.4,14.867 63.432,24.431 77.3,36.129 L 95.863,17.86 117.457,39.766 98.887,58.07 c 11.687,14.367 20.938,30.617 27.232,48.043 l 25.278,-6.552 7.742,29.738 -25.241,6.559 c 2.915,17.944 2.922,36.574 -0.445,55.245 l 25.175,6.949 -8.175,29.636 -25.175,-6.943 c -6.685,17.758 -16.255,33.784 -27.947,47.652 l 18.304,18.575 -21.905,21.599 -18.336,-18.623 c -14.336,11.734 -30.609,20.938 -48.012,27.28 l 6.558,25.242 -29.78,7.772 -6.564,-25.241 c -17.902,2.927 -36.568,2.921 -55.257,-0.41 l -6.932,25.14 -29.635,-8.181 6.93,-25.134 c -3.498,-1.347 -6.973,-2.771 -10.315,-4.376 -13.688,-6.198 -26.18,-14.241 -37.331,-23.607 l -18.563,18.263 -21.557,-21.894 18.575,-18.304 c -11.728,-14.379 -20.943,-30.616 -27.273,-48.055 l -25.254,6.6 -7.731,-29.774 25.2,-6.571 c -2.91,-17.938 -2.88,-36.561 0.445,-55.245 l -25.128,-6.937 8.176,-29.636 25.134,6.937 c 6.684,-17.764 16.254,-33.79 27.946,-47.658 l -18.269,-18.563 21.906,-21.599 18.293,18.617 C -118.665,22.886 -102.428,13.67 -84.989,7.34 l -6.559,-25.242 29.739,-7.742 6.565,25.2 c 14.379,-2.321 29.233,-2.819 44.153,-1.124 C -7.406,-1.19 -3.679,-0.673 0,0 Z" />
              </g>
              <g
                 id="g1148">
                <g
                   id="g1150" />
                <g
                   mask="url(#mask1172)"
                   id="g1198">
                  <g
                     id="g1200" />
                  <g
                     id="g1212">
                    <g
                       style={{opacity:0.72000098}}
                       id="g1210"
                      clipPath="url(#clipPath1204)">
                      <g
                         id="g1208"
                         transform="translate(281.377,36.7489)">
                        <path
                           
                           id="path1206"
                           style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                           d="m 0,0 -29.637,-8.182 -6.936,25.134 c -3.68,-0.673 -7.406,-1.19 -11.091,-1.569 l -86.522,313.609 c 3.342,1.605 6.816,3.029 10.315,4.376 l -6.931,25.134 29.636,8.181 6.931,-25.14 c 18.689,3.331 37.356,3.337 55.257,0.41 l 6.565,25.241 29.78,-7.772 -6.558,-25.242 C 8.212,327.838 24.484,318.634 38.821,306.9 l 18.336,18.623 21.904,-21.599 -18.304,-18.575 c 11.692,-13.868 21.262,-29.894 27.947,-47.652 l 25.176,6.943 8.175,-29.636 -25.175,-6.949 c 3.366,-18.671 3.36,-37.301 0.444,-55.245 l 25.242,-6.559 -7.742,-29.738 -25.278,6.552 C 83.251,105.639 74.001,89.389 62.314,75.022 L 80.883,56.718 59.29,34.812 40.727,53.081 C 26.859,41.383 10.826,31.819 -6.931,25.128 Z" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g
                 transform="translate(348.1758,216.0029)"
                 id="g1214">
                <path
                   
                   id="path1216"
                   style={{ fill: "#ff6d2e",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c 0,-73.002 -59.176,-132.178 -132.178,-132.178 -72.997,0 -132.174,59.176 -132.174,132.178 0,72.996 59.177,132.173 132.174,132.173 C -59.176,132.173 0,72.996 0,0" />
              </g>
              <g
                 transform="translate(348.1758,216.0029)"
                 id="g1218">
                <path
                   
                   id="path1220"
                   style={{ fill: "none",stroke:"#ffb17a",strokeWidth:4.09899998,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                   d="m 0,0 c 0,-73.002 -59.176,-132.178 -132.178,-132.178 -72.997,0 -132.174,59.176 -132.174,132.178 0,72.996 59.177,132.173 132.174,132.173 C -59.176,132.173 0,72.996 0,0 Z" />
              </g>
              <g
                 id="g1222">
                <g
                   id="g1224" />
                <g
                   mask="url(#mask1258)"
                   id="g1292">
                  <g
                     id="g1294" />
                  <g
                     id="g1306">
                    <g
                       id="g1304"
                      clipPath="url(#clipPath1298)">
                      <g
                         id="g1302"
                         transform="translate(345.8176,229.4342)">
                        <path
                           
                           id="path1300"
                           style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                           d="m 0,0 h -262.969 c 0.115,1.082 0.228,2.146 0.361,3.228 0.024,0.114 0.024,0.204 0.048,0.318 8.428,64.869 63.901,114.986 131.073,114.986 67.177,0 122.65,-50.117 131.078,-114.986 C -0.385,3.432 -0.385,3.342 -0.367,3.228 -0.229,2.146 -0.115,1.082 0,0" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <path
                 
                 id="path1308"
                 style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                 d="m 129.52,239.903 h 11.306 v -63.53 H 129.52 Z" />
              <g
                 transform="translate(168.2839,186.6027)"
                 id="g1310">
                <path
                   
                   id="path1312"
                   style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c 3.528,0 6.864,0.404 10.004,1.212 3.141,0.807 5.878,2.063 8.211,3.768 2.333,1.705 4.173,3.918 5.519,6.641 1.344,2.721 2.017,6.026 2.017,9.915 0,3.828 -0.597,7.118 -1.793,9.87 -1.198,2.751 -2.857,4.98 -4.98,6.685 -2.126,1.705 -4.637,2.961 -7.538,3.769 -2.902,0.807 -6.088,1.211 -9.556,1.211 H -8.434 V 0 Z M -19.741,53.301 H 5.293 c 4.188,0 8.224,-0.644 12.115,-1.93 3.888,-1.287 7.327,-3.245 10.318,-5.877 2.992,-2.633 5.383,-5.937 7.179,-9.915 C 36.698,31.6 37.597,26.92 37.597,21.536 37.597,16.092 36.564,11.38 34.5,7.403 32.438,3.424 29.774,0.135 26.514,-2.468 23.254,-5.07 19.634,-7.014 15.657,-8.3 11.679,-9.586 7.775,-10.229 3.948,-10.229 h -23.689 z" />
              </g>
              <g
                 transform="translate(228.5811,212.3562)"
                 id="g1314">
                <path
                   
                   id="path1316"
                   style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c 1.615,0 3.288,0.058 5.024,0.179 1.735,0.119 3.334,0.478 4.801,1.077 1.466,0.597 2.661,1.494 3.59,2.692 0.926,1.196 1.39,2.871 1.39,5.025 0,1.974 -0.419,3.544 -1.256,4.711 -0.839,1.166 -1.916,2.064 -3.231,2.692 -1.316,0.627 -2.781,1.032 -4.396,1.211 -1.616,0.18 -3.172,0.269 -4.666,0.269 H -6.82 V 0 Z M -18.125,27.547 H 3.229 c 3.052,0 5.997,-0.3 8.839,-0.897 2.84,-0.599 5.34,-1.602 7.493,-3.006 2.154,-1.407 3.872,-3.291 5.159,-5.653 1.286,-2.364 1.929,-5.31 1.929,-8.839 0,-4.008 -0.688,-7.238 -2.064,-9.69 C 23.208,-2.992 21.356,-4.89 19.022,-6.237 16.69,-7.582 13.982,-8.495 10.902,-8.973 7.82,-9.453 4.605,-9.691 1.256,-9.691 H -6.82 v -26.292 h -11.305 z" />
              </g>
              <g
                 transform="translate(277.2147,212.3562)"
                 id="g1318">
                <path
                   
                   id="path1320"
                   style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c 1.615,0 3.288,0.058 5.024,0.179 1.735,0.119 3.334,0.478 4.801,1.077 1.466,0.597 2.661,1.494 3.59,2.692 0.926,1.196 1.39,2.871 1.39,5.025 0,1.974 -0.419,3.544 -1.256,4.711 -0.839,1.166 -1.916,2.064 -3.231,2.692 -1.316,0.627 -2.781,1.032 -4.396,1.211 -1.616,0.18 -3.172,0.269 -4.666,0.269 H -6.82 V 0 Z M -18.125,27.547 H 3.229 c 3.052,0 5.997,-0.3 8.839,-0.897 2.84,-0.599 5.34,-1.602 7.493,-3.006 2.154,-1.407 3.872,-3.291 5.159,-5.653 1.286,-2.364 1.929,-5.31 1.929,-8.839 0,-4.008 -0.688,-7.238 -2.064,-9.69 C 23.208,-2.992 21.356,-4.89 19.022,-6.237 16.69,-7.582 13.982,-8.495 10.902,-8.973 7.82,-9.453 4.605,-9.691 1.256,-9.691 H -6.82 v -26.292 h -11.305 z" />
              </g>
            </g>
          </g>
          <g
             transform="translate(-185.21596,231.91348)"
             id="g3235">
            <text
              
               style={
	{
	 fontStyle:"normal",
	 fontWeight:"normal",
	 fontSize:"40px",
	 lineHeight:1.25,
	 fontFamily:"sans-serif",
	 letterSpacing:"0px",
	 wordSpacing:"0px",
	 fill:"#000000",
	 fillOpacity:1,
	 stroke:"none"
	}
}
               x="378.8255"
               y="850.78027"
               id="text3201"><tspan
                 
                 x="378.8255"
                 y="850.78027"
                 id="tspan3203"
                 style={{fontSize:"24px"}}>Instituto de la </tspan></text>
            <text
              
               style={{fontStyle:"normal",fontWeight:"normal",fontSize:"24px",fontFamily:"sans-serif",letterSpacing:"0px",wordSpacing:"0px",fill:"#000000",fillOpacity:1,stroke:"none"}}
               x="332.54816"
               y="872.21698"
               id="text3229"><tspan
                 
                 id="tspan3227"
                 x="332.54816"
                 y="872.21698">Defensa Pública Penal</tspan></text>
          </g>
        </g>
        <flowRoot
          
           id="flowRoot3237"
           style={{ fill: "black",fillOpacity:1,stroke:"none",fontFamily:"sans-serif",fontStyle:"normal",fontWeight:"normal",fontSize:"40px",lineHeight:1.25,letterSpacing:"0px",wordSpacing:"0px"}}><flowRegion
             id="flowRegion3239"><rect
               id="rect3241"
               width="217.89821"
               height="90.263069"
               x="668.26343"
               y="243.49243" /></flowRegion><flowPara
             id="flowPara3243"></flowPara></flowRoot>    
             <g id="g3875"   onClick={(evc)=>{
            props.history.push(goTo["SP"]);
        }} style={{cursor:"pointer"}}>
          <g
             transform="matrix(0.53835009,0,0,-0.53835009,657.62262,835.47264)"
             id="g12">
            <g
              clipPath="url(#clipPath18)"
               id="g14">
              <g
                 transform="translate(235.8006,145.4296)"
                 id="g20">
                <path
                   
                   id="path22"
                   style={{ fill: "#775543",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c -38.752,-10.945 -79.015,11.583 -89.959,50.335 -10.945,38.761 11.606,79.055 50.331,89.991 l 0.103,0.026 C -0.809,151.234 39.431,128.693 50.362,89.968 55.839,70.592 52.925,50.825 43.824,34.561 34.723,18.301 19.416,5.513 0.099,0.027 Z m -19.866,207.577 c -12.303,0 -24.785,-1.669 -37.191,-5.158 -73.003,-20.617 -115.563,-96.69 -94.973,-169.607 9.978,-35.326 33.109,-64.639 65.129,-82.558 32.024,-17.923 69.108,-22.294 104.429,-12.321 72.948,20.653 115.481,96.705 94.901,169.558 -17.074,60.47 -72.337,100.086 -132.295,100.086 m -0.198,-292.262 c -26.125,0 -51.927,6.673 -75.322,19.768 -36.077,20.189 -62.135,53.222 -73.362,93.007 -23.203,82.14 24.744,167.836 106.87,191.025 82.212,23.157 167.854,-24.812 191.034,-106.902 23.18,-82.072 -24.731,-167.742 -106.799,-190.971 -14.016,-3.966 -28.27,-5.927 -42.421,-5.927 m 50.322,-22.451 0.067,0.018 c 2.069,0.746 2.109,8.125 4.182,8.8 2.1,0.683 6.52,-5.455 8.589,-4.708 2.059,0.764 1.542,8.296 3.561,9.114 2.05,0.814 6.898,-4.968 8.903,-4.074 2.019,0.909 0.94,8.373 2.905,9.344 1.983,0.972 7.248,-4.437 9.177,-3.408 1.943,1.057 0.315,8.418 2.222,9.533 1.888,1.11 7.532,-3.903 9.384,-2.734 1.866,1.201 -0.301,8.426 1.511,9.677 1.812,1.25 7.806,-3.341 9.569,-2.028 1.772,1.326 -0.927,8.386 0.787,9.753 1.717,1.389 8.03,-2.752 9.703,-1.304 1.655,1.425 -1.542,8.265 0.077,9.775 1.601,1.493 8.21,-2.158 9.758,-0.602 1.546,1.556 -2.141,8.152 -0.644,9.766 1.493,1.61 8.346,-1.564 9.79,0.109 1.425,1.668 -2.739,7.972 -1.363,9.694 1.371,1.727 8.445,-0.935 9.753,0.819 1.309,1.78 -3.291,7.756 -2.055,9.573 1.246,1.812 8.494,-0.328 9.663,1.533 1.179,1.853 -3.848,7.496 -2.742,9.398 1.115,1.884 8.48,0.279 9.523,2.217 1.043,1.938 -4.379,7.199 -3.417,9.164 0.976,1.974 8.444,0.904 9.344,2.909 0.89,2.024 -4.901,6.871 -4.069,8.913 0.813,2.032 8.349,1.506 9.1,3.579 0.751,2.073 -5.386,6.479 -4.712,8.57 0.67,2.1 8.233,2.123 8.822,4.245 0.599,2.113 -5.85,6.075 -5.315,8.211 0.517,2.131 8.027,2.716 8.472,4.865 0.432,2.163 -6.273,5.634 -5.913,7.811 0.369,2.163 7.833,3.296 8.117,5.472 0.269,2.19 -6.673,5.158 -6.462,7.347 0.193,2.186 7.563,3.868 7.68,6.071 0.103,2.181 -7.042,4.641 -6.992,6.839 0.031,2.195 7.257,4.416 7.212,6.624 -0.053,2.19 -7.352,4.101 -7.469,6.304 -0.13,2.204 6.898,4.929 6.696,7.132 -0.202,2.176 -7.622,3.57 -7.91,5.746 -0.292,2.177 6.539,5.423 6.161,7.591 -0.36,2.176 -7.87,2.999 -8.306,5.171 -0.44,2.149 6.125,5.881 5.594,8.022 -0.512,2.131 -8.067,2.414 -8.669,4.541 -0.585,2.127 5.683,6.341 5.009,8.422 -0.67,2.109 -8.215,1.848 -8.957,3.903 -0.769,2.069 5.202,6.718 4.37,8.746 -0.809,2.046 -8.327,1.237 -9.222,3.247 -0.891,2.023 4.703,7.068 3.736,9.034 -0.957,1.987 -8.399,0.642 -9.429,2.572 -1.061,1.946 4.173,7.396 3.062,9.285 -1.115,1.902 -8.44,0.013 -9.609,1.87 -1.178,1.853 3.624,7.672 2.374,9.484 -1.25,1.812 -8.404,-0.607 -9.712,1.142 -1.313,1.776 3.049,7.937 1.668,9.636 -1.372,1.736 -8.328,-1.205 -9.771,0.445 -1.444,1.664 2.45,8.135 0.953,9.731 -1.502,1.619 -8.22,-1.83 -9.775,-0.288 -1.565,1.565 1.861,8.292 0.247,9.79 -1.61,1.492 -8.067,-2.442 -9.735,-0.999 -1.664,1.421 1.254,8.409 -0.464,9.762 -1.726,1.376 -7.878,-2.999 -9.64,-1.686 -1.777,1.3 0.629,8.463 -1.187,9.699 -1.813,1.246 -7.622,-3.575 -9.47,-2.396 -1.866,1.187 0.004,8.485 -1.893,9.586 -1.889,1.115 -7.348,-4.109 -9.286,-3.066 -1.933,1.043 -0.602,8.462 -2.572,9.443 -1.969,0.962 -7.037,-4.641 -9.043,-3.746 -2,0.895 -1.209,8.395 -3.246,9.213 -2.041,0.837 -6.682,-5.139 -8.75,-4.388 -2.055,0.76 -1.821,8.3 -3.908,8.975 -2.104,0.67 -6.286,-5.625 -8.404,-5.032 -2.113,0.598 -2.41,8.152 -4.56,8.665 -2.131,0.522 -5.836,-6.052 -8.004,-5.616 -2.149,0.44 -2.999,7.945 -5.175,8.287 -2.177,0.36 -5.396,-6.47 -7.568,-6.182 -2.194,0.283 -3.584,7.693 -5.792,7.9 -2.189,0.197 -4.892,-6.853 -7.091,-6.736 -2.203,0.122 -4.132,7.41 -6.349,7.455 -2.199,0.027 -4.384,-7.194 -6.588,-7.244 -2.189,-0.036 -4.676,7.096 -6.875,6.961 -2.194,-0.112 -3.826,-7.487 -6.025,-7.694 -2.19,-0.198 -5.194,6.736 -7.365,6.439 -2.177,-0.283 -3.283,-7.747 -5.473,-8.112 -2.159,-0.359 -5.657,6.327 -7.824,5.882 -2.127,-0.44 -2.698,-7.968 -4.843,-8.485 -2.109,-0.526 -6.016,5.76 -8.166,5.315 l -0.067,-0.013 c -2.123,-0.603 -2.136,-8.157 -4.227,-8.823 -2.1,-0.683 -6.52,5.441 -8.584,4.695 -2.064,-0.747 -1.543,-8.279 -3.57,-9.102 -2.06,-0.836 -6.907,4.951 -8.912,4.061 -2.006,-0.895 -0.922,-8.373 -2.905,-9.348 -1.97,-0.954 -7.235,4.456 -9.164,3.408 -1.943,-1.034 -0.329,-8.418 -2.217,-9.533 -1.889,-1.106 -7.55,3.903 -9.403,2.734 -1.852,-1.178 0.302,-8.426 -1.497,-9.672 -1.807,-1.255 -7.806,3.341 -9.569,2.028 -1.772,-1.313 0.922,-8.373 -0.8,-9.74 -1.709,-1.389 -8.04,2.747 -9.695,1.309 -1.664,-1.453 1.533,-8.296 -0.067,-9.794 -1.615,-1.502 -8.211,2.158 -9.758,0.602 -1.565,-1.56 2.118,-8.143 0.643,-9.752 -1.497,-1.61 -8.346,1.546 -9.794,-0.127 -1.421,-1.663 2.725,-7.967 1.363,-9.676 -1.371,-1.722 -8.445,0.944 -9.749,-0.837 -1.313,-1.758 3.287,-7.738 2.046,-9.55 -1.241,-1.817 -8.485,0.31 -9.659,-1.538 -1.169,-1.866 3.849,-7.491 2.739,-9.393 -1.106,-1.903 -8.494,-0.288 -9.519,-2.217 -1.039,-1.961 4.379,-7.199 3.404,-9.187 -0.958,-1.974 -8.427,-0.904 -9.326,-2.909 -0.9,-2.006 4.896,-6.848 4.06,-8.894 -0.814,-2.033 -8.345,-1.525 -9.096,-3.58 -0.751,-2.068 5.386,-6.479 4.698,-8.588 -0.661,-2.082 -8.21,-2.118 -8.808,-4.236 -0.594,-2.122 5.832,-6.066 5.315,-8.211 -0.513,-2.136 -8.045,-2.707 -8.486,-4.874 -0.436,-2.149 6.269,-5.621 5.927,-7.793 -0.369,-2.163 -7.833,-3.291 -8.112,-5.485 -0.274,-2.172 6.668,-5.14 6.457,-7.348 -0.193,-2.185 -7.559,-3.854 -7.68,-6.053 -0.117,-2.198 7.019,-4.645 6.997,-6.857 -0.036,-2.194 -7.267,-4.397 -7.222,-6.605 0.045,-2.19 7.357,-4.115 7.474,-6.323 0.13,-2.19 -6.912,-4.933 -6.709,-7.113 0.215,-2.199 7.635,-3.571 7.927,-5.76 0.288,-2.181 -6.543,-5.428 -6.183,-7.6 0.378,-2.153 7.874,-2.994 8.324,-5.161 0.44,-2.136 -6.13,-5.873 -5.595,-8.014 0.509,-2.127 8.058,-2.437 8.657,-4.559 0.598,-2.104 -5.603,-6.259 -5.001,-8.368 0,0 0.005,-0.018 0.005,-0.032 0.665,-2.104 8.215,-1.853 8.962,-3.916 0.75,-2.082 -5.207,-6.71 -4.398,-8.737 0.836,-2.059 8.355,-1.255 9.25,-3.26 0.89,-2.001 -4.708,-7.069 -3.755,-9.039 0.976,-1.982 8.413,-0.62 9.443,-2.549 1.056,-1.943 -4.169,-7.411 -3.058,-9.299 1.111,-1.893 8.418,-0.014 9.605,-1.857 1.178,-1.871 -3.624,-7.694 -2.374,-9.483 1.25,-1.817 8.404,0.602 9.712,-1.161 1.309,-1.762 -3.053,-7.923 -1.664,-9.64 1.367,-1.709 8.324,1.227 9.762,-0.423 1.449,-1.668 -2.45,-8.139 -0.953,-9.735 1.502,-1.615 8.224,1.839 9.785,0.274 1.556,-1.546 -1.866,-8.296 -0.257,-9.775 1.615,-1.493 8.076,2.428 9.74,0.998 1.673,-1.439 -1.254,-8.404 0.468,-9.776 1.726,-1.376 7.869,3.013 9.631,1.709 1.772,-1.304 -0.624,-8.467 1.188,-9.708 1.816,-1.255 7.626,3.565 9.478,2.388 1.867,-1.17 -0.004,-8.49 1.88,-9.605 1.902,-1.102 7.361,4.123 9.29,3.102 1.938,-1.047 0.589,-8.485 2.577,-9.447 1.974,-0.976 7.019,4.636 9.038,3.746 2.005,-0.895 1.2,-8.4 3.255,-9.232 2.037,-0.814 6.66,5.135 8.728,4.402 2.073,-0.755 1.821,-8.3 3.921,-8.966 2.087,-0.684 6.273,5.616 8.395,5 2.118,-0.593 2.424,-8.129 4.556,-8.642 2.149,-0.517 5.854,6.061 8.017,5.616 2.149,-0.436 2.999,-7.945 5.18,-8.305 2.163,-0.364 5.4,6.475 7.577,6.187 2.185,-0.27 3.579,-7.698 5.783,-7.887 2.185,-0.189 4.892,6.835 7.095,6.718 2.194,-0.099 4.132,-7.41 6.34,-7.437 2.203,-0.045 4.389,7.181 6.597,7.226 2.19,0.045 4.654,-7.083 6.862,-6.966 2.198,0.135 3.84,7.501 6.039,7.703 2.185,0.202 5.189,-6.713 7.365,-6.443 2.177,0.288 3.283,7.751 5.468,8.138 2.158,0.351 5.652,-6.335 7.806,-5.908 2.149,0.445 2.712,7.99 4.861,8.507 2.127,0.513 6.093,-5.899 8.211,-5.301" />
              </g>
              <g
                 transform="translate(235.8006,145.4296)"
                 id="g24">
                <path
                   
                   id="path26"
                   style={{ fill: "none",stroke:"#bfa179",strokeWidth:3,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                   d="m 0,0 c -38.752,-10.945 -79.015,11.583 -89.959,50.335 -10.945,38.761 11.606,79.055 50.331,89.991 l 0.103,0.026 C -0.809,151.234 39.431,128.693 50.362,89.968 55.839,70.592 52.925,50.825 43.824,34.561 34.723,18.301 19.416,5.513 0.099,0.027 Z m -19.866,207.577 c -12.303,0 -24.785,-1.669 -37.191,-5.158 -73.003,-20.617 -115.563,-96.69 -94.973,-169.607 9.978,-35.326 33.109,-64.639 65.129,-82.558 32.024,-17.923 69.108,-22.294 104.429,-12.321 72.948,20.653 115.481,96.705 94.901,169.558 -17.074,60.47 -72.337,100.086 -132.295,100.086 z m -0.198,-292.262 c -26.125,0 -51.927,6.673 -75.322,19.768 -36.077,20.189 -62.135,53.222 -73.362,93.007 -23.203,82.14 24.744,167.836 106.87,191.025 82.212,23.157 167.854,-24.812 191.034,-106.902 23.18,-82.072 -24.731,-167.742 -106.799,-190.971 -14.016,-3.966 -28.27,-5.927 -42.421,-5.927 z m 50.322,-22.451 0.067,0.018 c 2.069,0.746 2.109,8.125 4.182,8.8 2.1,0.683 6.52,-5.455 8.589,-4.708 2.059,0.764 1.542,8.296 3.561,9.114 2.05,0.814 6.898,-4.968 8.903,-4.074 2.019,0.909 0.94,8.373 2.905,9.344 1.983,0.972 7.248,-4.437 9.177,-3.408 1.943,1.057 0.315,8.418 2.222,9.533 1.888,1.11 7.532,-3.903 9.384,-2.734 1.866,1.201 -0.301,8.426 1.511,9.677 1.812,1.25 7.806,-3.341 9.569,-2.028 1.772,1.326 -0.927,8.386 0.787,9.753 1.717,1.389 8.03,-2.752 9.703,-1.304 1.655,1.425 -1.542,8.265 0.077,9.775 1.601,1.493 8.21,-2.158 9.758,-0.602 1.546,1.556 -2.141,8.152 -0.644,9.766 1.493,1.61 8.346,-1.564 9.79,0.109 1.425,1.668 -2.739,7.972 -1.363,9.694 1.371,1.727 8.445,-0.935 9.753,0.819 1.309,1.78 -3.291,7.756 -2.055,9.573 1.246,1.812 8.494,-0.328 9.663,1.533 1.179,1.853 -3.848,7.496 -2.742,9.398 1.115,1.884 8.48,0.279 9.523,2.217 1.043,1.938 -4.379,7.199 -3.417,9.164 0.976,1.974 8.444,0.904 9.344,2.909 0.89,2.024 -4.901,6.871 -4.069,8.913 0.813,2.032 8.349,1.506 9.1,3.579 0.751,2.073 -5.386,6.479 -4.712,8.57 0.67,2.1 8.233,2.123 8.822,4.245 0.599,2.113 -5.85,6.075 -5.315,8.211 0.517,2.131 8.027,2.716 8.472,4.865 0.432,2.163 -6.273,5.634 -5.913,7.811 0.369,2.163 7.833,3.296 8.117,5.472 0.269,2.19 -6.673,5.158 -6.462,7.347 0.193,2.186 7.563,3.868 7.68,6.071 0.103,2.181 -7.042,4.641 -6.992,6.839 0.031,2.195 7.257,4.416 7.212,6.624 -0.053,2.19 -7.352,4.101 -7.469,6.304 -0.13,2.204 6.898,4.929 6.696,7.132 -0.202,2.176 -7.622,3.57 -7.91,5.746 -0.292,2.177 6.539,5.423 6.161,7.591 -0.36,2.176 -7.87,2.999 -8.306,5.171 -0.44,2.149 6.125,5.881 5.594,8.022 -0.512,2.131 -8.067,2.414 -8.669,4.541 -0.585,2.127 5.683,6.341 5.009,8.422 -0.67,2.109 -8.215,1.848 -8.957,3.903 -0.769,2.069 5.202,6.718 4.37,8.746 -0.809,2.046 -8.327,1.237 -9.222,3.247 -0.891,2.023 4.703,7.068 3.736,9.034 -0.957,1.987 -8.399,0.642 -9.429,2.572 -1.061,1.946 4.173,7.396 3.062,9.285 -1.115,1.902 -8.44,0.013 -9.609,1.87 -1.178,1.853 3.624,7.672 2.374,9.484 -1.25,1.812 -8.404,-0.607 -9.712,1.142 -1.313,1.776 3.049,7.937 1.668,9.636 -1.372,1.736 -8.328,-1.205 -9.771,0.445 -1.444,1.664 2.45,8.135 0.953,9.731 -1.502,1.619 -8.22,-1.83 -9.775,-0.288 -1.565,1.565 1.861,8.292 0.247,9.79 -1.61,1.492 -8.067,-2.442 -9.735,-0.999 -1.664,1.421 1.254,8.409 -0.464,9.762 -1.726,1.376 -7.878,-2.999 -9.64,-1.686 -1.777,1.3 0.629,8.463 -1.187,9.699 -1.813,1.246 -7.622,-3.575 -9.47,-2.396 -1.866,1.187 0.004,8.485 -1.893,9.586 -1.889,1.115 -7.348,-4.109 -9.286,-3.066 -1.933,1.043 -0.602,8.462 -2.572,9.443 -1.969,0.962 -7.037,-4.641 -9.043,-3.746 -2,0.895 -1.209,8.395 -3.246,9.213 -2.041,0.837 -6.682,-5.139 -8.75,-4.388 -2.055,0.76 -1.821,8.3 -3.908,8.975 -2.104,0.67 -6.286,-5.625 -8.404,-5.032 -2.113,0.598 -2.41,8.152 -4.56,8.665 -2.131,0.522 -5.836,-6.052 -8.004,-5.616 -2.149,0.44 -2.999,7.945 -5.175,8.287 -2.177,0.36 -5.396,-6.47 -7.568,-6.182 -2.194,0.283 -3.584,7.693 -5.792,7.9 -2.189,0.197 -4.892,-6.853 -7.091,-6.736 -2.203,0.122 -4.132,7.41 -6.349,7.455 -2.199,0.027 -4.384,-7.194 -6.588,-7.244 -2.189,-0.036 -4.676,7.096 -6.875,6.961 -2.194,-0.112 -3.826,-7.487 -6.025,-7.694 -2.19,-0.198 -5.194,6.736 -7.365,6.439 -2.177,-0.283 -3.283,-7.747 -5.473,-8.112 -2.159,-0.359 -5.657,6.327 -7.824,5.882 -2.127,-0.44 -2.698,-7.968 -4.843,-8.485 -2.109,-0.526 -6.016,5.76 -8.166,5.315 l -0.067,-0.013 c -2.123,-0.603 -2.136,-8.157 -4.227,-8.823 -2.1,-0.683 -6.52,5.441 -8.584,4.695 -2.064,-0.747 -1.543,-8.279 -3.57,-9.102 -2.06,-0.836 -6.907,4.951 -8.912,4.061 -2.006,-0.895 -0.922,-8.373 -2.905,-9.348 -1.97,-0.954 -7.235,4.456 -9.164,3.408 -1.943,-1.034 -0.329,-8.418 -2.217,-9.533 -1.889,-1.106 -7.55,3.903 -9.403,2.734 -1.852,-1.178 0.302,-8.426 -1.497,-9.672 -1.807,-1.255 -7.806,3.341 -9.569,2.028 -1.772,-1.313 0.922,-8.373 -0.8,-9.74 -1.709,-1.389 -8.04,2.747 -9.695,1.309 -1.664,-1.453 1.533,-8.296 -0.067,-9.794 -1.615,-1.502 -8.211,2.158 -9.758,0.602 -1.565,-1.56 2.118,-8.143 0.643,-9.752 -1.497,-1.61 -8.346,1.546 -9.794,-0.127 -1.421,-1.663 2.725,-7.967 1.363,-9.676 -1.371,-1.722 -8.445,0.944 -9.749,-0.837 -1.313,-1.758 3.287,-7.738 2.046,-9.55 -1.241,-1.817 -8.485,0.31 -9.659,-1.538 -1.169,-1.866 3.849,-7.491 2.739,-9.393 -1.106,-1.903 -8.494,-0.288 -9.519,-2.217 -1.039,-1.961 4.379,-7.199 3.404,-9.187 -0.958,-1.974 -8.427,-0.904 -9.326,-2.909 -0.9,-2.006 4.896,-6.848 4.06,-8.894 -0.814,-2.033 -8.345,-1.525 -9.096,-3.58 -0.751,-2.068 5.386,-6.479 4.698,-8.588 -0.661,-2.082 -8.21,-2.118 -8.808,-4.236 -0.594,-2.122 5.832,-6.066 5.315,-8.211 -0.513,-2.136 -8.045,-2.707 -8.486,-4.874 -0.436,-2.149 6.269,-5.621 5.927,-7.793 -0.369,-2.163 -7.833,-3.291 -8.112,-5.485 -0.274,-2.172 6.668,-5.14 6.457,-7.348 -0.193,-2.185 -7.559,-3.854 -7.68,-6.053 -0.117,-2.198 7.019,-4.645 6.997,-6.857 -0.036,-2.194 -7.267,-4.397 -7.222,-6.605 0.045,-2.19 7.357,-4.115 7.474,-6.323 0.13,-2.19 -6.912,-4.933 -6.709,-7.113 0.215,-2.199 7.635,-3.571 7.927,-5.76 0.288,-2.181 -6.543,-5.428 -6.183,-7.6 0.378,-2.153 7.874,-2.994 8.324,-5.161 0.44,-2.136 -6.13,-5.873 -5.595,-8.014 0.509,-2.127 8.058,-2.437 8.657,-4.559 0.598,-2.104 -5.603,-6.259 -5.001,-8.368 0,0 0.005,-0.018 0.005,-0.032 0.665,-2.104 8.215,-1.853 8.962,-3.916 0.75,-2.082 -5.207,-6.71 -4.398,-8.737 0.836,-2.059 8.355,-1.255 9.25,-3.26 0.89,-2.001 -4.708,-7.069 -3.755,-9.039 0.976,-1.982 8.413,-0.62 9.443,-2.549 1.056,-1.943 -4.169,-7.411 -3.058,-9.299 1.111,-1.893 8.418,-0.014 9.605,-1.857 1.178,-1.871 -3.624,-7.694 -2.374,-9.483 1.25,-1.817 8.404,0.602 9.712,-1.161 1.309,-1.762 -3.053,-7.923 -1.664,-9.64 1.367,-1.709 8.324,1.227 9.762,-0.423 1.449,-1.668 -2.45,-8.139 -0.953,-9.735 1.502,-1.615 8.224,1.839 9.785,0.274 1.556,-1.546 -1.866,-8.296 -0.257,-9.775 1.615,-1.493 8.076,2.428 9.74,0.998 1.673,-1.439 -1.254,-8.404 0.468,-9.776 1.726,-1.376 7.869,3.013 9.631,1.709 1.772,-1.304 -0.624,-8.467 1.188,-9.708 1.816,-1.255 7.626,3.565 9.478,2.388 1.867,-1.17 -0.004,-8.49 1.88,-9.605 1.902,-1.102 7.361,4.123 9.29,3.102 1.938,-1.047 0.589,-8.485 2.577,-9.447 1.974,-0.976 7.019,4.636 9.038,3.746 2.005,-0.895 1.2,-8.4 3.255,-9.232 2.037,-0.814 6.66,5.135 8.728,4.402 2.073,-0.755 1.821,-8.3 3.921,-8.966 2.087,-0.684 6.273,5.616 8.395,5 2.118,-0.593 2.424,-8.129 4.556,-8.642 2.149,-0.517 5.854,6.061 8.017,5.616 2.149,-0.436 2.999,-7.945 5.18,-8.305 2.163,-0.364 5.4,6.475 7.577,6.187 2.185,-0.27 3.579,-7.698 5.783,-7.887 2.185,-0.189 4.892,6.835 7.095,6.718 2.194,-0.099 4.132,-7.41 6.34,-7.437 2.203,-0.045 4.389,7.181 6.597,7.226 2.19,0.045 4.654,-7.083 6.862,-6.966 2.198,0.135 3.84,7.501 6.039,7.703 2.185,0.202 5.189,-6.713 7.365,-6.443 2.177,0.288 3.283,7.751 5.468,8.138 2.158,0.351 5.652,-6.335 7.806,-5.908 2.149,0.445 2.712,7.99 4.861,8.507 2.127,0.513 6.093,-5.899 8.211,-5.301 z" />
              </g>
              <g
                 id="g28">
                <g
                   id="g30" />
                <g
                   mask="url(#mask52)"
                   id="g78">
                  <g
                     id="g80" />
                  <g
                     id="g92">
                    <g
                       id="g90"
                      clipPath="url(#clipPath84)">
                      <g
                         id="g88"
                         transform="translate(265.6736,39.1314)">
                        <path
                           
                           id="path86"
                           style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                           d="m 0,0 -100.135,354.593 c 2.15,0.446 6.057,-5.841 8.166,-5.315 2.145,0.517 2.716,8.045 4.843,8.485 2.168,0.445 5.666,-6.241 7.824,-5.881 2.19,0.364 3.296,7.828 5.473,8.111 2.171,0.297 5.175,-6.637 7.365,-6.439 2.199,0.207 3.831,7.582 6.026,7.694 2.198,0.135 4.685,-6.996 6.875,-6.96 2.203,0.049 4.389,7.271 6.587,7.243 2.217,-0.044 4.146,-7.333 6.349,-7.455 2.199,-0.117 4.902,6.934 7.091,6.736 2.208,-0.207 3.598,-7.617 5.792,-7.9 2.172,-0.288 5.391,6.542 7.568,6.182 2.176,-0.341 3.026,-7.846 5.175,-8.287 2.168,-0.436 5.873,6.138 8.004,5.617 2.15,-0.513 2.447,-8.068 4.56,-8.666 2.118,-0.593 6.3,5.702 8.404,5.032 2.087,-0.674 1.853,-8.215 3.908,-8.975 2.068,-0.751 6.709,5.225 8.75,4.389 2.037,-0.819 1.246,-8.319 3.246,-9.214 2.006,-0.895 7.074,4.708 9.043,3.746 1.97,-0.981 0.639,-8.4 2.572,-9.443 1.938,-1.043 7.397,4.182 9.286,3.066 1.897,-1.101 0.027,-8.399 1.893,-9.586 1.848,-1.179 7.658,3.642 9.47,2.396 1.816,-1.236 -0.589,-8.399 1.187,-9.699 1.763,-1.313 7.914,3.062 9.64,1.687 1.718,-1.354 -1.2,-8.342 0.464,-9.762 1.668,-1.444 8.125,2.491 9.735,0.998 1.614,-1.498 -1.812,-8.225 -0.247,-9.789 1.556,-1.543 8.273,1.906 9.775,0.287 1.497,-1.596 -2.397,-8.067 -0.953,-9.73 1.444,-1.651 8.4,1.29 9.771,-0.446 1.381,-1.699 -2.981,-7.86 -1.668,-9.636 1.308,-1.749 8.462,0.67 9.712,-1.142 1.25,-1.812 -3.552,-7.63 -2.374,-9.483 1.169,-1.857 8.494,0.031 9.609,-1.871 1.111,-1.888 -4.123,-7.338 -3.062,-9.285 1.03,-1.929 8.472,-0.585 9.43,-2.572 0.966,-1.965 -4.628,-7.011 -3.737,-9.034 0.895,-2.01 8.413,-1.201 9.222,-3.247 0.832,-2.027 -5.139,-6.677 -4.37,-8.745 0.742,-2.055 8.287,-1.795 8.957,-3.904 0.675,-2.081 -5.594,-6.295 -5.009,-8.422 0.602,-2.127 8.157,-2.41 8.67,-4.541 0.53,-2.141 -6.035,-5.873 -5.594,-8.022 0.436,-2.172 7.945,-2.995 8.305,-5.171 0.378,-2.168 -6.453,-5.414 -6.161,-7.591 0.288,-2.176 7.708,-3.57 7.91,-5.746 0.202,-2.203 -6.826,-4.928 -6.696,-7.132 0.117,-2.203 7.416,-4.114 7.469,-6.304 0.045,-2.208 -7.181,-4.429 -7.212,-6.624 -0.05,-2.198 7.096,-4.658 6.992,-6.839 -0.117,-2.203 -7.487,-3.885 -7.68,-6.07 -0.211,-2.19 6.731,-5.158 6.462,-7.348 -0.284,-2.176 -7.748,-3.309 -8.117,-5.472 -0.359,-2.176 6.345,-5.648 5.913,-7.811 -0.445,-2.149 -7.954,-2.734 -8.472,-4.865 -0.535,-2.136 5.914,-6.097 5.315,-8.211 -0.588,-2.122 -8.152,-2.145 -8.822,-4.245 -0.674,-2.091 5.463,-6.497 4.712,-8.57 -0.751,-2.073 -8.287,-1.547 -9.1,-3.579 -0.832,-2.042 4.959,-6.889 4.069,-8.913 -0.9,-2.005 -8.368,-0.935 -9.344,-2.909 -0.962,-1.965 4.461,-7.226 3.417,-9.164 -1.043,-1.938 -8.408,-0.333 -9.523,-2.217 -1.106,-1.902 3.921,-7.545 2.743,-9.398 -1.17,-1.861 -8.418,0.279 -9.664,-1.533 -1.236,-1.817 3.364,-7.793 2.055,-9.573 -1.308,-1.754 -8.382,0.908 -9.753,-0.819 -1.376,-1.722 2.788,-8.026 1.363,-9.694 -1.444,-1.673 -8.297,1.501 -9.79,-0.108 -1.497,-1.615 2.19,-8.211 0.644,-9.767 -1.547,-1.556 -8.157,2.095 -9.758,0.603 -1.619,-1.511 1.578,-8.351 -0.077,-9.776 -1.672,-1.448 -7.986,2.693 -9.703,1.304 -1.714,-1.367 0.985,-8.427 -0.787,-9.753 -1.763,-1.313 -7.757,3.278 -9.569,2.028 -1.812,-1.25 0.355,-8.476 -1.511,-9.677 -1.852,-1.169 -7.496,3.845 -9.384,2.734 -1.907,-1.115 -0.279,-8.476 -2.222,-9.533 -1.929,-1.029 -7.194,4.38 -9.177,3.409 C 26.175,17.505 27.254,10.041 25.235,9.133 23.23,8.238 18.382,14.02 16.332,13.207 14.313,12.388 14.83,4.856 12.771,4.092 10.702,3.346 6.282,9.483 4.182,8.8 2.109,8.126 2.069,0.746 0,0" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g
                 transform="translate(305.997,131.6561)"
                 id="g94">
                <path
                   
                   id="path96"
                   style={{ fill: "#775543",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c -46.351,-49.705 -124.223,-52.422 -173.929,-6.066 -49.71,46.351 -52.421,124.223 -6.07,173.933 46.36,49.705 124.232,52.422 173.938,6.071 C 43.644,127.582 46.356,49.705 0,0" />
              </g>
              <g
                 transform="translate(305.997,131.6561)"
                 id="g98">
                <path
                   
                   id="path100"
                   style={{ fill: "none",stroke:"#bfa179",strokeWidth:3,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                   d="m 0,0 c -46.351,-49.705 -124.223,-52.422 -173.929,-6.066 -49.71,46.351 -52.421,124.223 -6.07,173.933 46.36,49.705 124.232,52.422 173.938,6.071 C 43.644,127.582 46.356,49.705 0,0 Z" />
              </g>
              <g
                 id="g102">
                <g
                   id="g104" />
                <g
                   mask="url(#mask138)"
                   id="g172">
                  <g
                     id="g174" />
                  <g
                     id="g186">
                    <g
                       id="g184"
                      clipPath="url(#clipPath178)">
                      <g
                         id="g182"
                         transform="translate(314.194,141.3869)">
                        <path
                           
                           id="path180"
                           style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                           d="m 0,0 -179.055,166.986 c 0.765,0.665 1.512,1.312 2.294,1.969 0.09,0.063 0.144,0.126 0.234,0.185 46.93,38.819 116.529,37.721 162.269,-4.933 C 31.481,121.547 37.426,52.196 1.97,2.671 1.916,2.581 1.857,2.522 1.799,2.428 1.205,1.605 0.607,0.809 0,0" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g
                 transform="translate(197.0222,246.8074)"
                 id="g188">
                <path
                   
                   id="path190"
                   style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c -2.035,2.948 -4.754,5.109 -8.16,6.482 -3.407,1.372 -6.991,2.059 -10.752,2.059 -2.237,0 -4.399,-0.255 -6.482,-0.763 -2.085,-0.51 -3.965,-1.322 -5.642,-2.44 -1.678,-1.12 -3.027,-2.569 -4.042,-4.346 -1.017,-1.781 -1.525,-3.889 -1.525,-6.33 0,-3.66 1.27,-6.458 3.813,-8.388 2.54,-1.933 5.693,-3.61 9.456,-5.033 3.76,-1.425 7.877,-2.798 12.353,-4.117 4.473,-1.323 8.591,-3.153 12.354,-5.491 3.76,-2.34 6.913,-5.441 9.455,-9.304 2.541,-3.865 3.813,-8.998 3.813,-15.403 0,-5.796 -1.068,-10.855 -3.203,-15.175 -2.135,-4.323 -5.009,-7.907 -8.617,-10.752 -3.61,-2.848 -7.804,-4.983 -12.582,-6.406 -4.78,-1.422 -9.813,-2.135 -15.098,-2.135 -6.711,0 -13.169,1.12 -19.37,3.355 -6.203,2.236 -11.541,5.999 -16.013,11.286 l 14.488,14.031 c 2.338,-3.56 5.415,-6.329 9.227,-8.312 3.813,-1.982 7.855,-2.973 12.125,-2.973 2.235,0 4.473,0.304 6.711,0.915 2.234,0.609 4.27,1.524 6.1,2.745 1.83,1.22 3.303,2.768 4.423,4.651 1.117,1.88 1.677,4.041 1.677,6.482 0,3.966 -1.272,7.015 -3.812,9.151 -2.543,2.135 -5.696,3.939 -9.456,5.414 -3.763,1.473 -7.881,2.871 -12.354,4.193 -4.475,1.321 -8.593,3.127 -12.353,5.416 -3.763,2.287 -6.915,5.337 -9.456,9.15 -2.542,3.813 -3.812,8.922 -3.812,15.328 0,5.59 1.143,10.42 3.431,14.488 2.287,4.066 5.285,7.447 8.998,10.142 3.71,2.693 7.954,4.702 12.735,6.024 4.778,1.321 9.658,1.983 14.641,1.983 5.693,0 11.21,-0.865 16.548,-2.593 5.338,-1.73 10.142,-4.575 14.412,-8.54 z" />
              </g>
              <g
                 transform="translate(251.925,223.1682)"
                 id="g192">
                <path
                   
                   id="path194"
                   style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c 2.744,0 5.59,0.1 8.541,0.305 2.947,0.203 5.666,0.813 8.158,1.83 2.49,1.015 4.524,2.54 6.102,4.575 1.574,2.033 2.363,4.881 2.363,8.541 0,3.355 -0.713,6.024 -2.135,8.007 -1.425,1.983 -3.256,3.508 -5.49,4.575 -2.238,1.068 -4.728,1.754 -7.473,2.059 C 7.32,30.197 4.676,30.35 2.135,30.35 H -11.592 V 0 Z M -30.807,46.821 H 5.49 c 5.186,0 10.192,-0.51 15.022,-1.525 4.828,-1.018 9.076,-2.721 12.736,-5.109 3.66,-2.39 6.582,-5.593 8.77,-9.608 2.183,-4.018 3.277,-9.025 3.277,-15.023 0,-6.813 -1.17,-12.303 -3.506,-16.471 -2.342,-4.17 -5.492,-7.397 -9.457,-9.685 -3.965,-2.288 -8.566,-3.839 -13.803,-4.651 -5.236,-0.816 -10.701,-1.221 -16.394,-1.221 h -13.727 v -44.686 h -19.215 z" />
              </g>
            </g>
          </g>
          <text
             id="text3247"
             y="843.5462"
             x="643.9978"
             style={
	{
	 fontStyle:"normal",
	 fontWeight:"normal",
	 fontSize:"40px",
	 lineHeight:1.25,
	 fontFamily:"sans-serif",
	 letterSpacing:"0px",
	 wordSpacing:"0px",
	 fill:"#000000",
	 fillOpacity:1,
	 stroke:"none"
	}
}
            ><tspan
               style={{fontSize:"24px"}}
               y="843.5462"
               x="643.9978"
               id="tspan3245"
               >Sistema Penitenciario</tspan></text>
        </g>
        <flowRoot
          
           id="flowRoot3249"
           style={{ fill: "black",fillOpacity:1,stroke:"none",fontFamily:"sans-serif",fontStyle:"normal",fontWeight:"normal",fontSize:"40px",lineHeight:1.25,letterSpacing:"0px",wordSpacing:"0px"}}><flowRegion
             id="flowRegion3251"><rect
               id="rect3253"
               width="249.25275"
               height="112.11623"
               x="158.35626"
               y="470.57532" /></flowRegion><flowPara
             id="flowPara3255"></flowPara></flowRoot>    
             <g id="g3841" transform="translate(-8.0214539)"  onClick={(evc)=>{
            props.history.push(goTo["MP"]);
        }} style={{cursor:"pointer"}}>
          <g
             transform="matrix(0.54380083,0,0,-0.54380083,334.20744,836.86782)"
             id="g380">
            <g
              clipPath="url(#clipPath386)"
               id="g382">
              <g
                 transform="translate(235.6015,146.5471)"
                 id="g388">
                <path
                   
                   id="path390"
                   style={{ fill: "#c1a738",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c -38.37,-10.833 -78.226,11.466 -89.054,49.832 -10.834,38.362 11.48,78.245 49.822,89.073 l 0.1,0.029 C -0.809,149.705 39.023,127.397 49.851,89.064 55.266,69.881 52.382,50.308 43.381,34.213 34.37,18.118 19.217,5.453 0.095,0.024 Z m -19.677,205.485 c -12.171,0 -24.531,-1.646 -36.816,-5.11 -72.259,-20.406 -114.393,-95.711 -94.011,-167.899 9.876,-34.964 32.775,-63.986 64.475,-81.723 31.701,-17.741 68.407,-22.061 103.371,-12.194 72.217,20.439 114.322,95.725 93.95,167.851 -16.899,59.862 -71.613,99.075 -130.969,99.075 m -0.2,-289.31 c -25.854,0 -51.388,6.608 -74.554,19.568 -35.71,19.978 -61.502,52.672 -72.621,92.061 -22.97,81.309 24.493,166.138 105.792,189.099 81.385,22.923 166.158,-24.564 189.109,-105.82 C 150.79,29.836 103.366,-54.97 22.124,-77.974 8.25,-81.889 -5.852,-83.825 -19.877,-83.825 m 49.822,-22.233 0.076,0.024 c 2.046,0.732 2.089,8.035 4.13,8.711 2.084,0.671 6.461,-5.405 8.507,-4.667 2.036,0.761 1.522,8.206 3.53,9.025 2.022,0.804 6.822,-4.92 8.811,-4.039 1.994,0.908 0.928,8.292 2.874,9.253 1.96,0.966 7.169,-4.391 9.087,-3.373 1.917,1.042 0.304,8.336 2.198,9.434 1.865,1.109 7.451,-3.863 9.287,-2.697 1.851,1.175 -0.295,8.331 1.494,9.577 1.803,1.237 7.726,-3.307 9.468,-2.017 1.77,1.318 -0.904,8.307 0.78,9.658 1.708,1.38 7.955,-2.717 9.61,-1.285 1.642,1.409 -1.527,8.184 0.076,9.678 1.58,1.475 8.127,-2.141 9.668,-0.6 1.523,1.542 -2.122,8.069 -0.647,9.668 1.485,1.598 8.269,-1.547 9.692,0.105 1.413,1.655 -2.708,7.892 -1.347,9.601 1.361,1.703 8.359,-0.933 9.653,0.808 1.29,1.76 -3.259,7.679 -2.031,9.478 1.232,1.798 8.412,-0.329 9.563,1.517 1.17,1.832 -3.806,7.413 -2.717,9.302 1.109,1.864 8.398,0.276 9.435,2.198 1.028,1.912 -4.339,7.122 -3.388,9.068 0.966,1.96 8.364,0.899 9.245,2.878 0.889,2.013 -4.848,6.804 -4.021,8.826 0.8,2.017 8.264,1.494 9.006,3.549 0.748,2.046 -5.333,6.413 -4.667,8.478 0.666,2.079 8.145,2.094 8.735,4.196 0.595,2.094 -5.785,6.014 -5.262,8.131 0.514,2.113 7.946,2.693 8.393,4.815 0.419,2.146 -6.214,5.576 -5.852,7.731 0.357,2.141 7.745,3.264 8.036,5.424 0.257,2.17 -6.613,5.1 -6.4,7.27 0.186,2.165 7.48,3.83 7.599,6.004 0.099,2.165 -6.971,4.596 -6.923,6.78 0.029,2.164 7.189,4.368 7.146,6.551 -0.057,2.165 -7.279,4.058 -7.403,6.242 -0.128,2.179 6.832,4.877 6.633,7.061 -0.2,2.159 -7.541,3.539 -7.832,5.69 -0.285,2.15 6.471,5.371 6.1,7.512 -0.357,2.15 -7.784,2.969 -8.222,5.115 -0.437,2.131 6.062,5.823 5.539,7.945 -0.51,2.108 -7.984,2.398 -8.584,4.491 -0.58,2.113 5.629,6.28 4.958,8.341 -0.661,2.078 -8.136,1.831 -8.868,3.863 -0.752,2.055 5.147,6.651 4.329,8.659 -0.799,2.022 -8.245,1.227 -9.134,3.211 -0.886,2.003 4.657,6.994 3.701,8.949 -0.952,1.965 -8.317,0.633 -9.335,2.541 -1.046,1.927 4.13,7.317 3.036,9.197 -1.104,1.884 -8.355,0.014 -9.516,1.851 -1.165,1.836 3.597,7.592 2.351,9.381 -1.242,1.804 -8.321,-0.594 -9.611,1.133 -1.304,1.765 3.017,7.859 1.646,9.548 -1.356,1.709 -8.24,-1.199 -9.672,0.438 -1.422,1.647 2.431,8.05 0.947,9.63 -1.485,1.603 -8.146,-1.818 -9.673,-0.29 -1.555,1.555 1.842,8.211 0.243,9.701 -1.599,1.474 -7.988,-2.422 -9.639,-0.995 -1.651,1.408 1.237,8.326 -0.466,9.663 -1.704,1.361 -7.794,-2.969 -9.535,-1.67 -1.76,1.289 0.619,8.378 -1.175,9.606 -1.799,1.232 -7.55,-3.54 -9.377,-2.379 -1.846,1.175 0.009,8.402 -1.875,9.496 -1.865,1.099 -7.27,-4.072 -9.192,-3.04 -1.912,1.033 -0.595,8.378 -2.55,9.345 -1.941,0.951 -6.961,-4.597 -8.939,-3.707 -1.984,0.885 -1.214,8.316 -3.221,9.121 -2.027,0.822 -6.614,-5.082 -8.664,-4.339 -2.036,0.747 -1.799,8.216 -3.859,8.887 -2.089,0.661 -6.232,-5.571 -8.325,-4.981 -2.094,0.589 -2.384,8.069 -4.516,8.578 -2.107,0.509 -5.78,-5.995 -7.921,-5.567 -2.127,0.438 -2.974,7.865 -5.129,8.207 -2.15,0.352 -5.338,-6.404 -7.493,-6.118 -2.17,0.281 -3.545,7.612 -5.724,7.812 -2.169,0.2 -4.843,-6.775 -7.022,-6.661 -2.179,0.124 -4.092,7.337 -6.285,7.38 -2.174,0.028 -4.334,-7.123 -6.523,-7.17 -2.169,-0.043 -4.624,7.027 -6.808,6.888 -2.17,-0.114 -3.792,-7.412 -5.962,-7.612 -2.169,-0.2 -5.138,6.661 -7.293,6.38 -2.156,-0.29 -3.245,-7.679 -5.419,-8.045 -2.132,-0.352 -5.595,6.271 -7.736,5.824 -2.117,-0.433 -2.674,-7.889 -4.805,-8.398 -2.084,-0.518 -5.952,5.705 -8.079,5.262 l -0.067,-0.014 c -2.102,-0.6 -2.117,-8.078 -4.177,-8.735 -2.088,-0.676 -6.461,5.386 -8.502,4.653 -2.05,-0.743 -1.536,-8.193 -3.54,-9.011 -2.036,-0.828 -6.836,4.905 -8.82,4.015 -1.984,-0.88 -0.909,-8.283 -2.874,-9.253 -1.955,-0.943 -7.16,4.415 -9.063,3.377 -1.932,-1.022 -0.333,-8.33 -2.208,-9.434 -1.865,-1.099 -7.469,3.863 -9.301,2.693 -1.837,-1.152 0.3,-8.331 -1.489,-9.563 -1.789,-1.242 -7.722,3.307 -9.464,2.008 -1.765,-1.304 0.91,-8.288 -0.798,-9.639 -1.69,-1.38 -7.955,2.716 -9.592,1.284 -1.651,-1.427 1.513,-8.202 -0.067,-9.687 -1.603,-1.484 -8.131,2.137 -9.662,0.6 -1.552,-1.551 2.093,-8.069 0.637,-9.654 -1.485,-1.598 -8.269,1.533 -9.687,-0.128 -1.422,-1.646 2.688,-7.893 1.342,-9.582 -1.361,-1.698 -8.364,0.933 -9.658,-0.827 -1.294,-1.742 3.254,-7.66 2.027,-9.459 -1.228,-1.784 -8.393,0.314 -9.563,-1.513 -1.161,-1.846 3.811,-7.417 2.721,-9.306 -1.104,-1.879 -8.411,-0.281 -9.43,-2.198 -1.032,-1.932 4.33,-7.122 3.374,-9.092 -0.957,-1.946 -8.341,-0.889 -9.235,-2.879 -0.885,-1.988 4.843,-6.779 4.02,-8.801 -0.814,-2.017 -8.255,-1.503 -9.006,-3.54 -0.747,-2.055 5.333,-6.413 4.643,-8.502 -0.647,-2.065 -8.126,-2.098 -8.706,-4.201 -0.59,-2.093 5.766,-6.004 5.257,-8.126 -0.509,-2.112 -7.969,-2.678 -8.397,-4.824 -0.438,-2.122 6.204,-5.557 5.856,-7.717 -0.356,-2.132 -7.745,-3.254 -8.026,-5.429 -0.266,-2.146 6.604,-5.086 6.395,-7.269 -0.191,-2.165 -7.485,-3.816 -7.603,-5.99 -0.114,-2.189 6.946,-4.606 6.927,-6.794 -0.033,-2.17 -7.194,-4.354 -7.146,-6.533 0.038,-2.174 7.279,-4.077 7.403,-6.266 0.119,-2.159 -6.851,-4.886 -6.651,-7.041 0.223,-2.169 7.56,-3.53 7.85,-5.699 0.285,-2.156 -6.471,-5.372 -6.119,-7.527 0.371,-2.127 7.794,-2.96 8.236,-5.115 0.433,-2.108 -6.066,-5.799 -5.538,-7.921 0.509,-2.108 7.979,-2.412 8.574,-4.515 0.585,-2.089 -5.543,-6.199 -4.953,-8.288 v -0.029 c 0.666,-2.079 8.145,-1.832 8.872,-3.877 0.748,-2.065 -5.147,-6.637 -4.348,-8.645 0.823,-2.041 8.264,-1.242 9.154,-3.23 0.88,-1.984 -4.658,-6.999 -3.716,-8.945 0.961,-1.96 8.321,-0.618 9.344,-2.526 1.052,-1.918 -4.129,-7.341 -3.021,-9.211 1.099,-1.865 8.331,-0.005 9.511,-1.832 1.161,-1.851 -3.597,-7.612 -2.36,-9.391 1.247,-1.789 8.326,0.599 9.62,-1.142 1.299,-1.751 -3.026,-7.846 -1.646,-9.549 1.351,-1.689 8.231,1.213 9.667,-0.424 1.428,-1.646 -2.435,-8.049 -0.946,-9.629 1.489,-1.599 8.14,1.817 9.682,0.266 1.541,-1.532 -1.846,-8.206 -0.248,-9.667 1.589,-1.485 7.984,2.397 9.639,0.989 1.656,-1.432 -1.242,-8.326 0.466,-9.686 1.704,-1.361 7.794,2.988 9.535,1.689 1.751,-1.29 -0.623,-8.378 1.17,-9.606 1.799,-1.247 7.546,3.53 9.382,2.365 1.837,-1.161 0,-8.407 1.861,-9.506 1.879,-1.099 7.279,4.087 9.196,3.064 1.918,-1.033 0.586,-8.398 2.555,-9.345 1.956,-0.97 6.942,4.592 8.945,3.707 1.984,-0.885 1.184,-8.321 3.221,-9.135 2.017,-0.809 6.599,5.077 8.64,4.353 2.055,-0.742 1.803,-8.216 3.882,-8.877 2.07,-0.676 6.209,5.561 8.311,4.952 2.099,-0.585 2.398,-8.05 4.506,-8.559 2.131,-0.509 5.795,6.004 7.945,5.562 2.122,-0.433 2.969,-7.86 5.129,-8.217 2.141,-0.361 5.334,6.409 7.489,6.119 2.169,-0.267 3.549,-7.617 5.728,-7.798 2.165,-0.2 4.844,6.761 7.022,6.642 2.17,-0.096 4.092,-7.332 6.281,-7.361 2.179,-0.043 4.338,7.108 6.532,7.156 2.164,0.043 4.605,-7.018 6.789,-6.894 2.179,0.129 3.801,7.422 5.976,7.617 2.169,0.205 5.133,-6.647 7.288,-6.375 2.161,0.28 3.255,7.679 5.415,8.054 2.141,0.358 5.6,-6.275 7.731,-5.847 2.127,0.443 2.688,7.908 4.81,8.421 2.108,0.5 6.033,-5.842 8.126,-5.247" />
              </g>
              <g
                 transform="translate(235.6015,146.5471)"
                 id="g392">
                <path
                   
                   id="path394"
                   style={{ fill: "none",stroke:"#d1c342",strokeWidth:3,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                   d="m 0,0 c -38.37,-10.833 -78.226,11.466 -89.054,49.832 -10.834,38.362 11.48,78.245 49.822,89.073 l 0.1,0.029 C -0.809,149.705 39.023,127.397 49.851,89.064 55.266,69.881 52.382,50.308 43.381,34.213 34.37,18.118 19.217,5.453 0.095,0.024 Z m -19.677,205.485 c -12.171,0 -24.531,-1.646 -36.816,-5.11 -72.259,-20.406 -114.393,-95.711 -94.011,-167.899 9.876,-34.964 32.775,-63.986 64.475,-81.723 31.701,-17.741 68.407,-22.061 103.371,-12.194 72.217,20.439 114.322,95.725 93.95,167.851 -16.899,59.862 -71.613,99.075 -130.969,99.075 z m -0.2,-289.31 c -25.854,0 -51.388,6.608 -74.554,19.568 -35.71,19.978 -61.502,52.672 -72.621,92.061 -22.97,81.309 24.493,166.138 105.792,189.099 81.385,22.923 166.158,-24.564 189.109,-105.82 C 150.79,29.836 103.366,-54.97 22.124,-77.974 8.25,-81.889 -5.852,-83.825 -19.877,-83.825 Z m 49.822,-22.233 0.076,0.024 c 2.046,0.732 2.089,8.035 4.13,8.711 2.084,0.671 6.461,-5.405 8.507,-4.667 2.036,0.761 1.522,8.206 3.53,9.025 2.022,0.804 6.822,-4.92 8.811,-4.039 1.994,0.908 0.928,8.292 2.874,9.253 1.96,0.966 7.169,-4.391 9.087,-3.373 1.917,1.042 0.304,8.336 2.198,9.434 1.865,1.109 7.451,-3.863 9.287,-2.697 1.851,1.175 -0.295,8.331 1.494,9.577 1.803,1.237 7.726,-3.307 9.468,-2.017 1.77,1.318 -0.904,8.307 0.78,9.658 1.708,1.38 7.955,-2.717 9.61,-1.285 1.642,1.409 -1.527,8.184 0.076,9.678 1.58,1.475 8.127,-2.141 9.668,-0.6 1.523,1.542 -2.122,8.069 -0.647,9.668 1.485,1.598 8.269,-1.547 9.692,0.105 1.413,1.655 -2.708,7.892 -1.347,9.601 1.361,1.703 8.359,-0.933 9.653,0.808 1.29,1.76 -3.259,7.679 -2.031,9.478 1.232,1.798 8.412,-0.329 9.563,1.517 1.17,1.832 -3.806,7.413 -2.717,9.302 1.109,1.864 8.398,0.276 9.435,2.198 1.028,1.912 -4.339,7.122 -3.388,9.068 0.966,1.96 8.364,0.899 9.245,2.878 0.889,2.013 -4.848,6.804 -4.021,8.826 0.8,2.017 8.264,1.494 9.006,3.549 0.748,2.046 -5.333,6.413 -4.667,8.478 0.666,2.079 8.145,2.094 8.735,4.196 0.595,2.094 -5.785,6.014 -5.262,8.131 0.514,2.113 7.946,2.693 8.393,4.815 0.419,2.146 -6.214,5.576 -5.852,7.731 0.357,2.141 7.745,3.264 8.036,5.424 0.257,2.17 -6.613,5.1 -6.4,7.27 0.186,2.165 7.48,3.83 7.599,6.004 0.099,2.165 -6.971,4.596 -6.923,6.78 0.029,2.164 7.189,4.368 7.146,6.551 -0.057,2.165 -7.279,4.058 -7.403,6.242 -0.128,2.179 6.832,4.877 6.633,7.061 -0.2,2.159 -7.541,3.539 -7.832,5.69 -0.285,2.15 6.471,5.371 6.1,7.512 -0.357,2.15 -7.784,2.969 -8.222,5.115 -0.437,2.131 6.062,5.823 5.539,7.945 -0.51,2.108 -7.984,2.398 -8.584,4.491 -0.58,2.113 5.629,6.28 4.958,8.341 -0.661,2.078 -8.136,1.831 -8.868,3.863 -0.752,2.055 5.147,6.651 4.329,8.659 -0.799,2.022 -8.245,1.227 -9.134,3.211 -0.886,2.003 4.657,6.994 3.701,8.949 -0.952,1.965 -8.317,0.633 -9.335,2.541 -1.046,1.927 4.13,7.317 3.036,9.197 -1.104,1.884 -8.355,0.014 -9.516,1.851 -1.165,1.836 3.597,7.592 2.351,9.381 -1.242,1.804 -8.321,-0.594 -9.611,1.133 -1.304,1.765 3.017,7.859 1.646,9.548 -1.356,1.709 -8.24,-1.199 -9.672,0.438 -1.422,1.647 2.431,8.05 0.947,9.63 -1.485,1.603 -8.146,-1.818 -9.673,-0.29 -1.555,1.555 1.842,8.211 0.243,9.701 -1.599,1.474 -7.988,-2.422 -9.639,-0.995 -1.651,1.408 1.237,8.326 -0.466,9.663 -1.704,1.361 -7.794,-2.969 -9.535,-1.67 -1.76,1.289 0.619,8.378 -1.175,9.606 -1.799,1.232 -7.55,-3.54 -9.377,-2.379 -1.846,1.175 0.009,8.402 -1.875,9.496 -1.865,1.099 -7.27,-4.072 -9.192,-3.04 -1.912,1.033 -0.595,8.378 -2.55,9.345 -1.941,0.951 -6.961,-4.597 -8.939,-3.707 -1.984,0.885 -1.214,8.316 -3.221,9.121 -2.027,0.822 -6.614,-5.082 -8.664,-4.339 -2.036,0.747 -1.799,8.216 -3.859,8.887 -2.089,0.661 -6.232,-5.571 -8.325,-4.981 -2.094,0.589 -2.384,8.069 -4.516,8.578 -2.107,0.509 -5.78,-5.995 -7.921,-5.567 -2.127,0.438 -2.974,7.865 -5.129,8.207 -2.15,0.352 -5.338,-6.404 -7.493,-6.118 -2.17,0.281 -3.545,7.612 -5.724,7.812 -2.169,0.2 -4.843,-6.775 -7.022,-6.661 -2.179,0.124 -4.092,7.337 -6.285,7.38 -2.174,0.028 -4.334,-7.123 -6.523,-7.17 -2.169,-0.043 -4.624,7.027 -6.808,6.888 -2.17,-0.114 -3.792,-7.412 -5.962,-7.612 -2.169,-0.2 -5.138,6.661 -7.293,6.38 -2.156,-0.29 -3.245,-7.679 -5.419,-8.045 -2.132,-0.352 -5.595,6.271 -7.736,5.824 -2.117,-0.433 -2.674,-7.889 -4.805,-8.398 -2.084,-0.518 -5.952,5.705 -8.079,5.262 l -0.067,-0.014 c -2.102,-0.6 -2.117,-8.078 -4.177,-8.735 -2.088,-0.676 -6.461,5.386 -8.502,4.653 -2.05,-0.743 -1.536,-8.193 -3.54,-9.011 -2.036,-0.828 -6.836,4.905 -8.82,4.015 -1.984,-0.88 -0.909,-8.283 -2.874,-9.253 -1.955,-0.943 -7.16,4.415 -9.063,3.377 -1.932,-1.022 -0.333,-8.33 -2.208,-9.434 -1.865,-1.099 -7.469,3.863 -9.301,2.693 -1.837,-1.152 0.3,-8.331 -1.489,-9.563 -1.789,-1.242 -7.722,3.307 -9.464,2.008 -1.765,-1.304 0.91,-8.288 -0.798,-9.639 -1.69,-1.38 -7.955,2.716 -9.592,1.284 -1.651,-1.427 1.513,-8.202 -0.067,-9.687 -1.603,-1.484 -8.131,2.137 -9.662,0.6 -1.552,-1.551 2.093,-8.069 0.637,-9.654 -1.485,-1.598 -8.269,1.533 -9.687,-0.128 -1.422,-1.646 2.688,-7.893 1.342,-9.582 -1.361,-1.698 -8.364,0.933 -9.658,-0.827 -1.294,-1.742 3.254,-7.66 2.027,-9.459 -1.228,-1.784 -8.393,0.314 -9.563,-1.513 -1.161,-1.846 3.811,-7.417 2.721,-9.306 -1.104,-1.879 -8.411,-0.281 -9.43,-2.198 -1.032,-1.932 4.33,-7.122 3.374,-9.092 -0.957,-1.946 -8.341,-0.889 -9.235,-2.879 -0.885,-1.988 4.843,-6.779 4.02,-8.801 -0.814,-2.017 -8.255,-1.503 -9.006,-3.54 -0.747,-2.055 5.333,-6.413 4.643,-8.502 -0.647,-2.065 -8.126,-2.098 -8.706,-4.201 -0.59,-2.093 5.766,-6.004 5.257,-8.126 -0.509,-2.112 -7.969,-2.678 -8.397,-4.824 -0.438,-2.122 6.204,-5.557 5.856,-7.717 -0.356,-2.132 -7.745,-3.254 -8.026,-5.429 -0.266,-2.146 6.604,-5.086 6.395,-7.269 -0.191,-2.165 -7.485,-3.816 -7.603,-5.99 -0.114,-2.189 6.946,-4.606 6.927,-6.794 -0.033,-2.17 -7.194,-4.354 -7.146,-6.533 0.038,-2.174 7.279,-4.077 7.403,-6.266 0.119,-2.159 -6.851,-4.886 -6.651,-7.041 0.223,-2.169 7.56,-3.53 7.85,-5.699 0.285,-2.156 -6.471,-5.372 -6.119,-7.527 0.371,-2.127 7.794,-2.96 8.236,-5.115 0.433,-2.108 -6.066,-5.799 -5.538,-7.921 0.509,-2.108 7.979,-2.412 8.574,-4.515 0.585,-2.089 -5.543,-6.199 -4.953,-8.288 v -0.029 c 0.666,-2.079 8.145,-1.832 8.872,-3.877 0.748,-2.065 -5.147,-6.637 -4.348,-8.645 0.823,-2.041 8.264,-1.242 9.154,-3.23 0.88,-1.984 -4.658,-6.999 -3.716,-8.945 0.961,-1.96 8.321,-0.618 9.344,-2.526 1.052,-1.918 -4.129,-7.341 -3.021,-9.211 1.099,-1.865 8.331,-0.005 9.511,-1.832 1.161,-1.851 -3.597,-7.612 -2.36,-9.391 1.247,-1.789 8.326,0.599 9.62,-1.142 1.299,-1.751 -3.026,-7.846 -1.646,-9.549 1.351,-1.689 8.231,1.213 9.667,-0.424 1.428,-1.646 -2.435,-8.049 -0.946,-9.629 1.489,-1.599 8.14,1.817 9.682,0.266 1.541,-1.532 -1.846,-8.206 -0.248,-9.667 1.589,-1.485 7.984,2.397 9.639,0.989 1.656,-1.432 -1.242,-8.326 0.466,-9.686 1.704,-1.361 7.794,2.988 9.535,1.689 1.751,-1.29 -0.623,-8.378 1.17,-9.606 1.799,-1.247 7.546,3.53 9.382,2.365 1.837,-1.161 0,-8.407 1.861,-9.506 1.879,-1.099 7.279,4.087 9.196,3.064 1.918,-1.033 0.586,-8.398 2.555,-9.345 1.956,-0.97 6.942,4.592 8.945,3.707 1.984,-0.885 1.184,-8.321 3.221,-9.135 2.017,-0.809 6.599,5.077 8.64,4.353 2.055,-0.742 1.803,-8.216 3.882,-8.877 2.07,-0.676 6.209,5.561 8.311,4.952 2.099,-0.585 2.398,-8.05 4.506,-8.559 2.131,-0.509 5.795,6.004 7.945,5.562 2.122,-0.433 2.969,-7.86 5.129,-8.217 2.141,-0.361 5.334,6.409 7.489,6.119 2.169,-0.267 3.549,-7.617 5.728,-7.798 2.165,-0.2 4.844,6.761 7.022,6.642 2.17,-0.096 4.092,-7.332 6.281,-7.361 2.179,-0.043 4.338,7.108 6.532,7.156 2.164,0.043 4.605,-7.018 6.789,-6.894 2.179,0.129 3.801,7.422 5.976,7.617 2.169,0.205 5.133,-6.647 7.288,-6.375 2.161,0.28 3.255,7.679 5.415,8.054 2.141,0.358 5.6,-6.275 7.731,-5.847 2.127,0.443 2.688,7.908 4.81,8.421 2.108,0.5 6.033,-5.842 8.126,-5.247 z" />
              </g>
              <g
                 id="g396">
                <g
                   id="g398" />
                <g
                   mask="url(#mask420)"
                   id="g446">
                  <g
                     id="g448" />
                  <g
                     id="g460">
                    <g
                       id="g458"
                      clipPath="url(#clipPath452)">
                      <g
                         id="g456"
                         transform="translate(265.623,40.5128)">
                        <path
                           
                           id="path454"
                           style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                           d="m 0,0 -99.131,351.013 c 2.126,0.442 5.994,-5.781 8.078,-5.263 2.132,0.51 2.688,7.965 4.805,8.398 2.141,0.447 5.605,-6.175 7.736,-5.824 2.175,0.367 3.264,7.755 5.419,8.046 2.156,0.28 5.125,-6.58 7.294,-6.38 2.169,0.2 3.792,7.498 5.961,7.612 2.184,0.138 4.639,-6.932 6.809,-6.889 2.188,0.047 4.348,7.198 6.523,7.17 2.193,-0.043 4.105,-7.256 6.284,-7.38 2.18,-0.114 4.853,6.861 7.023,6.661 2.179,-0.199 3.554,-7.531 5.723,-7.812 2.155,-0.285 5.343,6.471 7.494,6.118 2.155,-0.342 3.002,-7.769 5.128,-8.206 2.141,-0.429 5.814,6.075 7.922,5.566 2.131,-0.509 2.422,-7.988 4.515,-8.578 2.094,-0.59 6.237,5.642 8.326,4.981 2.06,-0.671 1.822,-8.14 3.858,-8.887 2.051,-0.742 6.637,5.162 8.664,4.339 2.008,-0.804 1.237,-8.236 3.221,-9.121 1.979,-0.889 6.999,4.658 8.94,3.707 1.955,-0.966 0.637,-8.312 2.55,-9.344 1.922,-1.033 7.327,4.139 9.192,3.04 1.884,-1.095 0.028,-8.321 1.874,-9.497 1.827,-1.161 7.579,3.611 9.378,2.379 1.793,-1.227 -0.585,-8.316 1.175,-9.606 1.741,-1.298 7.831,3.031 9.534,1.671 1.703,-1.338 -1.184,-8.255 0.466,-9.663 1.651,-1.428 8.041,2.469 9.639,0.994 1.599,-1.489 -1.798,-8.145 -0.242,-9.701 1.527,-1.527 8.188,1.893 9.672,0.29 1.485,-1.579 -2.369,-7.983 -0.946,-9.629 1.432,-1.637 8.316,1.27 9.672,-0.438 1.37,-1.689 -2.95,-7.783 -1.646,-9.549 1.289,-1.727 8.369,0.671 9.61,-1.132 1.247,-1.789 -3.516,-7.546 -2.35,-9.382 1.161,-1.837 8.411,0.033 9.515,-1.851 1.095,-1.879 -4.082,-7.27 -3.035,-9.197 1.018,-1.907 8.383,-0.575 9.334,-2.54 0.957,-1.956 -4.586,-6.947 -3.701,-8.949 0.89,-1.984 8.335,-1.19 9.135,-3.212 0.818,-2.008 -5.081,-6.604 -4.33,-8.659 0.733,-2.031 8.207,-1.784 8.869,-3.863 0.67,-2.06 -5.538,-6.228 -4.958,-8.34 0.6,-2.094 8.074,-2.384 8.583,-4.492 0.523,-2.122 -5.976,-5.814 -5.538,-7.945 0.438,-2.146 7.865,-2.964 8.221,-5.115 0.371,-2.14 -6.384,-5.362 -6.099,-7.512 0.29,-2.15 7.631,-3.53 7.831,-5.69 0.2,-2.184 -6.761,-4.882 -6.632,-7.06 0.124,-2.184 7.346,-4.078 7.403,-6.243 0.043,-2.183 -7.118,-4.386 -7.146,-6.551 -0.048,-2.184 7.022,-4.615 6.922,-6.779 -0.119,-2.175 -7.412,-3.84 -7.598,-6.005 -0.214,-2.169 6.656,-5.1 6.399,-7.269 -0.29,-2.161 -7.679,-3.284 -8.035,-5.424 -0.362,-2.156 6.27,-5.586 5.852,-7.731 -0.448,-2.123 -7.879,-2.703 -8.393,-4.815 -0.523,-2.118 5.857,-6.038 5.262,-8.131 -0.59,-2.103 -8.069,-2.117 -8.735,-4.197 -0.666,-2.064 5.414,-6.432 4.667,-8.478 -0.742,-2.055 -8.207,-1.532 -9.006,-3.549 -0.828,-2.022 4.91,-6.813 4.02,-8.826 -0.88,-1.979 -8.278,-0.918 -9.244,-2.878 -0.952,-1.946 4.415,-7.155 3.388,-9.068 -1.038,-1.922 -8.326,-0.333 -9.435,-2.198 -1.09,-1.889 3.887,-7.47 2.716,-9.302 -1.151,-1.845 -8.33,0.282 -9.562,-1.517 -1.228,-1.798 3.32,-7.717 2.031,-9.477 -1.294,-1.742 -8.293,0.894 -9.653,-0.809 -1.361,-1.708 2.759,-7.946 1.346,-9.601 -1.422,-1.651 -8.207,1.494 -9.691,-0.105 -1.475,-1.598 2.169,-8.126 0.647,-9.668 -1.542,-1.541 -8.088,2.075 -9.668,0.6 -1.603,-1.494 1.565,-8.269 -0.076,-9.677 -1.656,-1.432 -7.902,2.664 -9.61,1.284 -1.685,-1.351 0.989,-8.34 -0.781,-9.658 -1.741,-1.289 -7.664,3.255 -9.467,2.018 -1.789,-1.247 0.356,-8.403 -1.495,-9.578 -1.836,-1.165 -7.421,3.807 -9.286,2.698 -1.894,-1.099 -0.281,-8.393 -2.198,-9.435 -1.918,-1.018 -7.128,4.34 -9.087,3.374 C 25.905,17.322 26.971,9.939 24.978,9.03 22.989,8.15 18.189,13.873 16.166,13.069 14.159,12.251 14.673,4.805 12.636,4.044 10.59,3.307 6.213,9.382 4.129,8.711 2.089,8.036 2.046,0.733 0,0" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g
                 transform="translate(294.0499,126.227)"
                 id="g462">
                <path
                   
                   id="path464"
                   style={{ fill: "#c1a738",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c -49.584,-42.633 -124.333,-37 -166.966,12.58 -42.629,49.579 -36.991,124.332 12.584,166.961 49.575,42.638 124.333,37.005 166.962,-12.579 C 55.213,117.377 49.575,42.634 0,0" />
              </g>
              <g
                 transform="translate(294.0499,126.227)"
                 id="g466">
                <path
                   
                   id="path468"
                   style={{ fill: "none",stroke:"#d1c342",strokeWidth:3,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                   d="m 0,0 c -49.584,-42.633 -124.333,-37 -166.966,12.58 -42.629,49.579 -36.991,124.332 12.584,166.961 49.575,42.638 124.333,37.005 166.962,-12.579 C 55.213,117.377 49.575,42.634 0,0 Z" />
              </g>
              <g
                 id="g470">
                <g
                   id="g472" />
                <g
                   mask="url(#mask506)"
                   id="g540">
                  <g
                     id="g542" />
                  <g
                     id="g554">
                    <g
                       id="g552"
                      clipPath="url(#clipPath546)">
                      <g
                         id="g550"
                         transform="translate(302.9089,134.6627)">
                        <path
                           
                           id="path548"
                           style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                           d="m 0,0 -153.569,178.608 c 0.8,0.552 1.585,1.099 2.398,1.632 0.09,0.057 0.152,0.119 0.238,0.162 48.99,32.157 115.421,23.75 154.654,-21.876 C 42.952,112.9 41.306,45.959 2.169,2.35 2.103,2.269 2.036,2.222 1.984,2.131 1.323,1.408 0.671,0.714 0,0" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g
                 transform="translate(134.6782,252.923)"
                 id="g556">
                <path
                   
                   id="path558"
                   style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 24.32,0.042 24.05,-62.786 24.085,62.87 24.067,0.042 0.156,-89.681 -15.201,-0.027 -0.13,74.481 H 81.094 L 53.99,-89.587 42.843,-89.608 15.48,-15.173 l -0.254,-10e-4 0.13,-74.482 -15.2,-0.026 z" />
              </g>
              <g
                 transform="translate(268.5074,214.2685)"
                 id="g560">
                <path
                   
                   id="path562"
                   style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                   d="m 0,0 c 2.28,0.004 4.643,0.09 7.094,0.265 2.447,0.173 4.704,0.684 6.773,1.532 2.067,0.847 3.753,2.116 5.061,3.809 1.304,1.691 1.955,4.057 1.951,7.096 -0.006,2.787 -0.601,5.003 -1.785,6.648 -1.187,1.644 -2.709,2.909 -4.567,3.792 -1.86,0.883 -3.929,1.45 -6.21,1.7 C 6.037,25.09 3.839,25.213 1.73,25.21 L -9.671,25.19 -9.627,-0.017 Z m -25.655,38.842 30.148,0.053 c 4.307,0.007 8.465,-0.409 12.479,-1.245 4.011,-0.839 7.541,-2.247 10.584,-4.225 3.043,-1.98 5.475,-4.636 7.297,-7.968 1.821,-3.333 2.737,-7.49 2.745,-12.472 0.01,-5.658 -0.953,-10.22 -2.89,-13.685 -1.937,-3.468 -4.548,-6.152 -7.839,-8.057 -3.291,-1.905 -7.109,-3.202 -11.456,-3.883 -4.35,-0.685 -8.888,-1.03 -13.616,-1.038 l -11.401,-0.02 0.065,-37.113 -15.96,-0.028 z" />
              </g>
            </g>
          </g>
          <text
             id="text3259"
             y="845.4212"
             x="346.24066"
             style={
	{
	 fontStyle:"normal",
	 fontWeight:"normal",
	 fontSize:"40px",
	 lineHeight:1.25,
	 fontFamily:"sans-serif",
	 letterSpacing:"0px",
	 wordSpacing:"0px",
	 fill:"#000000",
	 fillOpacity:1,
	 stroke:"none"
	}
}
            ><tspan
               style={{fontSize:"24px"}}
               y="845.4212"
               x="346.24066"
               id="tspan3257"
               >Ministerio Público</tspan></text>
        </g>
        <flowRoot
          
           id="flowRoot3261"
           style={{ fill: "black",fillOpacity:1,stroke:"none",fontFamily:"sans-serif",fontStyle:"normal",fontWeight:"normal",fontSize:"40px",lineHeight:1.25,letterSpacing:"0px",wordSpacing:"0px"}}><flowRegion
             id="flowRegion3263"><rect
               id="rect3265"
               width="260.02097"
               height="42.122765"
               x="540.31158"
               y="475.6427" /></flowRegion><flowPara
             id="flowPara3267"></flowPara></flowRoot>    <flowRoot
          
           id="flowRoot3277"
           style={{ fill: "black",fillOpacity:1,stroke:"none",fontFamily:"sans-serif",fontStyle:"normal",fontWeight:"normal",fontSize:"40px",lineHeight:1.25,letterSpacing:"0px",wordSpacing:"0px"}}><flowRegion
             id="flowRegion3279"><rect
               id="rect3281"
               width="253.68672"
               height="49.090439"
               x="472.21835"
               y="475.95941" /></flowRegion><flowPara
             id="flowPara3283"></flowPara></flowRoot>    
             <g
           transform="translate(-37.614804,-1.3420399)"
           id="g3375-5"
           onClick={(evc)=>{
            props.history.push(goTo["INACIF"]);
        }} style={{cursor:"pointer"}}>
          <g
             transform="matrix(0.53680127,0,0,-0.53680127,-8.1734085,1285.9932)"
             id="g1528-0">
            <g
               id="g752-2"
               transform="translate(1079.5801,396.09171)">
              <g
                 id="g754-7"
                clipPath="url(#clipPath758-6)">
                <g
                   id="g760-8">
                  <g
                     id="g762-3" />
                  <g
                     id="g786-1"
                     mask="url(#mask774-9)">
                    <g
                       id="g788-3">
                      <path
                         d="m 205.055,362.732 c -3.859,-0.17 -8.835,9.057 -13.818,18.284 v 0 c -5.13,9.498 -10.266,18.996 -14.195,18.244 v 0 c -7.702,-1.47 -5.16,-41.691 -12.632,-44.271 v 0 c -3.637,-1.248 -11.004,6.191 -18.385,13.629 v 0 c -7.609,7.668 -15.231,15.336 -18.796,13.491 v 0 c -6.938,-3.547 6.892,-41.401 0.423,-46.035 v 0 c -3.116,-2.205 -12.247,2.841 -21.412,7.886 v 0 c -9.477,5.218 -18.991,10.435 -21.932,7.639 v 0 c -5.778,-5.496 18.127,-37.965 13.327,-44.078 v 0 c -2.444,-3.066 -12.726,-0.787 -22.981,1.491 v 0 c -10.513,2.337 -20.997,4.673 -22.971,1.25 v 0 c -3.976,-6.827 28.134,-31.239 25.218,-38.494 v 0 C 73.957,264.439 33.91,268.995 32.045,261.38 v 0 c -1.834,-7.652 35.83,-22.002 35.08,-29.824 v 0 C 66.374,223.743 26.64,216.851 27.014,208.996 v 0 c 0.345,-7.845 40.521,-11.056 42.009,-18.795 v 0 c 1.451,-7.698 -34.73,-25.466 -32.165,-32.924 v 0 c 1.28,-3.737 11.999,-3.475 22.753,-3.212 v 0 c 10.514,0.256 21.064,0.514 22.868,-2.966 v 0 c 3.552,-6.924 -26.125,-34.214 -21.523,-40.673 v 0 c 2.273,-3.205 12.469,0.084 22.708,3.373 v 0 c 10.017,3.217 20.075,6.435 22.798,3.574 v 0 c 5.51,-5.786 -15.332,-40.291 -9.237,-45.081 v 0 c 3.166,-2.51 12.142,3.551 21.093,9.612 v 0 c 8.669,5.869 17.314,11.74 20.63,9.823 v 0 c 6.837,-3.994 -3.39,-42.967 3.861,-45.86 v 0 c 3.714,-1.501 10.58,6.835 17.44,15.172 v 0 c 6.661,8.095 13.317,16.19 17.074,15.278 v 0 c 7.638,-1.861 8.845,-42.151 16.639,-42.925 v 0 c 7.85,-0.737 16.705,38.595 24.563,38.963 v 0 c 3.864,0.172 8.846,-9.056 13.832,-18.285 v 0 c 5.13,-9.496 10.264,-18.992 14.192,-18.246 v 0 c 7.697,1.456 5.154,41.706 12.622,44.262 v 0 c 3.643,1.249 11.008,-6.189 18.388,-13.625 v 0 c 7.606,-7.666 15.229,-15.331 18.811,-13.486 v 0 c 6.947,3.552 -6.909,41.424 -0.423,46.026 v 0 c 3.109,2.216 12.243,-2.828 21.41,-7.871 v 0 c 9.47,-5.209 18.976,-10.419 21.911,-7.626 v 0 c 5.782,5.496 -18.117,37.959 -13.303,44.045 v 0 c 2.433,3.09 12.742,0.807 23.013,-1.475 v 0 c 10.504,-2.335 20.97,-4.669 22.939,-1.257 v 0 c 3.961,6.85 -28.124,31.248 -25.223,38.494 v 0 c 2.925,7.339 42.995,2.779 44.843,10.403 v 0 c 1.847,7.647 -35.823,21.987 -35.058,29.796 v 0 c 0.746,7.832 40.471,14.727 40.107,22.582 v 0 c -0.35,7.841 -40.535,11.056 -42.005,18.795 v 0 c -1.497,7.69 34.717,25.458 32.16,32.929 v 0 c -1.293,3.739 -12.022,3.473 -22.779,3.206 v 0 c -10.514,-0.261 -21.054,-0.521 -22.837,2.959 v 0 c -3.561,6.938 26.111,34.223 21.495,40.7 v 0 c -2.273,3.196 -12.463,-0.096 -22.7,-3.388 v 0 c -10.019,-3.222 -20.081,-6.444 -22.8,-3.582 v 0 c -5.501,5.781 15.331,40.286 9.254,45.096 v 0 c -3.17,2.503 -12.145,-3.556 -21.092,-9.615 v 0 c -8.671,-5.87 -17.317,-11.742 -20.631,-9.821 v 0 c -6.86,3.966 3.367,42.962 -3.879,45.874 v 0 c -3.718,1.48 -10.581,-6.852 -17.435,-15.184 v 0 c -6.661,-8.097 -13.312,-16.193 -17.06,-15.285 v 0 c -7.666,1.87 -8.845,42.147 -16.663,42.898 v 0 c -0.074,0.007 -0.149,0.01 -0.223,0.01 v 0 c -7.773,0.005 -16.559,-38.595 -24.336,-38.952 M 183.21,190.367 c -14.999,15.769 -14.377,40.737 1.41,55.755 v 0 c 15.792,15.014 40.752,14.373 55.75,-1.396 v 0 c 15.01,-15.787 14.397,-40.751 -1.396,-55.759 v 0 c -7.632,-7.259 -17.415,-10.861 -27.177,-10.862 v 0 c -10.43,0 -20.837,4.109 -28.587,12.262"
                         style={{ fill: "url(#linearGradient3639)",stroke:"none"}}
                         id="path796-7"
                          />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g
               id="g1492-2">
              <g
                 transform="translate(1079.7071,395.98271)"
                 id="g798-3">
                <g
                  clipPath="url(#clipPath804-6)"
                   id="g800-7">
                  <g
                     transform="translate(183.2104,190.3669)"
                     id="g806-0">
                    <path
                       
                       id="path808-5"
                       style={{ fill: "none",stroke:"#656666",strokeWidth:3,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                       d="M 0,0 C -15,15.769 -14.378,40.737 1.41,55.755 17.201,70.769 42.161,70.129 57.16,54.359 72.169,38.572 71.556,13.608 55.764,-1.401 39.977,-16.414 15.004,-15.783 0,0 Z m 156.058,-106.863 c 5.782,5.496 -18.118,37.96 -13.304,44.045 4.924,6.252 42.059,-9.48 45.952,-2.731 3.962,6.85 -28.124,31.247 -25.222,38.493 2.925,7.339 42.995,2.778 44.842,10.402 1.848,7.648 -35.822,21.988 -35.057,29.797 0.746,7.832 40.47,14.728 40.106,22.582 -0.35,7.841 -40.535,11.057 -42.004,18.796 -1.497,7.689 34.717,25.457 32.16,32.929 -2.557,7.393 -42.009,-0.876 -45.617,6.164 -3.56,6.937 26.112,34.223 21.496,40.7 -4.496,6.326 -40.001,-12.756 -45.501,-6.97 -5.5,5.782 15.331,40.286 9.255,45.096 -6.243,4.929 -34.988,-23.338 -41.723,-19.436 -6.86,3.966 3.367,42.963 -3.879,45.874 -7.33,2.921 -26.89,-32.312 -34.496,-30.469 -7.665,1.87 -8.845,42.147 -16.662,42.898 -7.827,0.756 -16.709,-38.582 -24.559,-38.941 -7.831,-0.345 -20.265,38.011 -28.014,36.527 -7.702,-1.469 -5.159,-41.691 -12.631,-44.271 -7.385,-2.534 -30.156,30.755 -37.181,27.12 -6.938,-3.547 6.891,-41.401 0.423,-46.035 -6.338,-4.482 -37.558,21.025 -43.345,15.525 -5.777,-5.496 18.128,-37.965 13.328,-44.078 -4.948,-6.21 -42.05,9.504 -45.953,2.741 -3.975,-6.827 28.134,-31.238 25.218,-38.494 -2.944,-7.329 -42.991,-2.773 -44.856,-10.388 -1.833,-7.652 35.831,-22.002 35.08,-29.824 -0.751,-7.813 -40.484,-14.705 -40.111,-22.559 0.346,-7.846 40.521,-11.057 42.009,-18.796 1.451,-7.698 -34.73,-25.466 -32.164,-32.925 2.533,-7.389 41.972,0.862 45.62,-6.177 3.553,-6.924 -26.125,-34.215 -21.522,-40.673 4.496,-6.339 40,12.733 45.505,6.947 5.51,-5.786 -15.331,-40.291 -9.236,-45.082 6.233,-4.938 34.983,23.333 41.723,19.436 6.837,-3.994 -3.39,-42.967 3.861,-45.86 7.32,-2.958 26.889,32.302 34.513,30.45 7.638,-1.861 8.845,-42.151 16.64,-42.925 7.85,-0.737 16.704,38.595 24.563,38.964 7.841,0.35 20.279,-38.001 28.023,-36.532 7.698,1.456 5.155,41.705 12.623,44.262 7.398,2.538 30.141,-30.745 37.199,-27.111 6.947,3.552 -6.91,41.424 -0.424,46.026 6.32,4.506 37.545,-20.993 43.322,-15.497 z" />
                  </g>
                  <g
                     transform="translate(301.8201,122.8872)"
                     id="g810-5">
                    <path
                       
                       id="path812-2"
                       style={{ fill: "#414141",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                       d="m 0,0 c -52.282,-49.72 -134.959,-47.643 -184.685,4.639 -49.72,52.287 -47.643,134.964 4.639,184.685 3.294,3.137 6.708,6.076 10.251,8.794 0.843,0.659 1.699,1.295 2.556,1.939 0.101,0.069 0.166,0.129 0.267,0.184 C -114.777,238.39 -41.12,232.793 4.634,184.689 50.384,136.581 52.282,62.726 11.558,12.512 11.494,12.424 11.425,12.36 11.355,12.258 10.679,11.425 9.992,10.628 9.292,9.803 6.408,6.399 3.303,3.137 0,0" />
                  </g>
                  <g
                     transform="translate(301.8201,122.8872)"
                     id="g814-2">
                    <path
                       
                       id="path816-7"
                       style={{ fill: "none",stroke:"#221f1f",strokeWidth:3,strokeLinecap:"butt",strokeLinejoin:"miter",strokeMiterlimit:10,strokeDasharray:"none",strokeOpacity:1}}
                       d="m 0,0 c -52.282,-49.72 -134.959,-47.643 -184.685,4.639 -49.72,52.287 -47.643,134.964 4.639,184.685 3.294,3.137 6.708,6.076 10.251,8.794 0.843,0.659 1.699,1.295 2.556,1.939 0.101,0.069 0.166,0.129 0.267,0.184 C -114.777,238.39 -41.12,232.793 4.634,184.689 50.384,136.581 52.282,62.726 11.558,12.512 11.494,12.424 11.425,12.36 11.355,12.258 10.679,11.425 9.992,10.628 9.292,9.803 6.408,6.399 3.303,3.137 0,0 Z" />
                  </g>
                  <g
                     id="g818-0">
                    <g
                       id="g820-9" />
                    <g
                       mask="url(#mask854-2)"
                       id="g888-4">
                      <g
                         id="g890-8" />
                      <g
                         id="g902-8">
                        <g
                           id="g900-0"
                          clipPath="url(#clipPath894-9)">
                          <g
                             id="g898-0"
                             transform="translate(311.1118,132.6902)">
                            <path
                               
                               id="path896-2"
                               style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                               d="m 0,0 -179.087,188.315 c 0.843,0.659 1.7,1.295 2.557,1.939 0.101,0.069 0.165,0.129 0.267,0.184 52.194,38.149 125.851,32.552 171.606,-15.552 C 41.092,126.778 42.99,52.923 2.267,2.709 2.202,2.621 2.133,2.557 2.064,2.455 1.387,1.622 0.701,0.825 0,0" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <path
                     
                     id="path904-4"
                     style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                     d="m 108.033,243.603 h 9.507 v -53.421 h -9.507 z" />
                  <g
                     transform="translate(124.0293,243.6027)"
                     id="g906-8">
                    <path
                       
                       id="path908-5"
                       style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                       d="m 0,0 h 12.601 l 25.88,-39.689 h 0.151 V 0 h 9.507 V -53.421 H 36.066 L 9.658,-12.45 H 9.507 V -53.421 H 0 Z" />
                  </g>
                  <g
                     transform="translate(208.2334,210.5538)"
                     id="g910-7">
                    <path
                       
                       id="path912-2"
                       style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                       d="M 0,0 -8.224,21.73 -16.6,0 Z m -12.072,33.049 h 8.224 L 19.166,-20.373 H 8.301 L 3.32,-8.149 h -23.164 l -4.829,-12.224 h -10.639 z" />
                  </g>
                  <g
                     transform="translate(264.8223,231.0773)"
                     id="g914-2">
                    <path
                       
                       id="path916-1"
                       style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                       d="m 0,0 c -1.962,2.113 -3.861,3.521 -5.696,4.226 -1.837,0.703 -3.686,1.056 -5.546,1.056 -2.768,0 -5.271,-0.49 -7.508,-1.471 -2.239,-0.981 -4.163,-2.34 -5.772,-4.075 -1.611,-1.736 -2.856,-3.761 -3.735,-6.074 -0.881,-2.314 -1.32,-4.804 -1.32,-7.47 0,-2.867 0.439,-5.508 1.32,-7.922 0.879,-2.415 2.124,-4.503 3.735,-6.264 1.609,-1.761 3.533,-3.144 5.772,-4.149 2.237,-1.007 4.74,-1.51 7.508,-1.51 2.162,0 4.263,0.516 6.3,1.547 2.037,1.03 3.935,2.679 5.697,4.942 l 7.847,-5.584 c -2.415,-3.319 -5.358,-5.734 -8.829,-7.243 -3.47,-1.509 -7.168,-2.263 -11.09,-2.263 -4.126,0 -7.912,0.668 -11.357,2 -3.445,1.332 -6.413,3.218 -8.903,5.659 -2.49,2.438 -4.44,5.368 -5.848,8.79 -1.408,3.42 -2.112,7.218 -2.112,11.393 0,4.275 0.704,8.161 2.112,11.658 1.408,3.496 3.358,6.476 5.848,8.941 2.49,2.464 5.458,4.363 8.903,5.697 3.445,1.332 7.231,1.999 11.357,1.999 3.621,0 6.978,-0.641 10.072,-1.924 C 1.849,10.677 4.728,8.5 7.395,5.433 Z" />
                  </g>
                  <path
                     
                     id="path918-2"
                     style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                     d="m 274.405,243.603 h 9.507 v -53.421 h -9.507 z" />
                  <g
                     transform="translate(290.4014,243.6027)"
                     id="g920-0">
                    <path
                       
                       id="path922-9"
                       style={{ fill: "#ffffff",fillOpacity:1,fillRule:"nonzero",stroke:"none"}}
                       d="M 0,0 H 34.481 V -8.602 H 9.507 v -14.034 h 23.541 v -8.602 H 9.507 V -53.421 H 0 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g
             id="g3293-7">
            <text
              
               style={
	{
	 fontStyle:"normal",
	 fontWeight:"normal",
	 fontSize:"40px",
	 lineHeight:1.25,
	 fontFamily:"sans-serif",
	 letterSpacing:"0px",
	 wordSpacing:"0px",
	 fill:"#000000",
	 fillOpacity:1,
	 stroke:"none"
	}
}
               x="578.72607"
               y="1083.781"
               id="text3271-7"><tspan
                 
                 x="578.72607"
                 y="1083.781"
                 id="tspan3273-4"
                 style={{fontSize:"24px"}}>Instituto Nacional</tspan></text>
            <text
              
               style={
	{
	 fontStyle:"normal",
	 fontWeight:"normal",
	 fontSize:"40px",
	 lineHeight:1.25,
	 fontFamily:"sans-serif",
	 letterSpacing:"0px",
	 wordSpacing:"0px",
	 fill:"#000000",
	 fillOpacity:1,
	 stroke:"none"
	}
}
               x="558.99756"
               y="1105.0183"
               id="text3287-3"><tspan
                 
                 id="tspan3285-8"
                 x="558.99756"
                 y="1105.0183"
                 style={{fontSize:"24px"}}>de Ciencias Forenses</tspan></text>
          </g>
        </g>
      </g>
    </svg></>;
    
}